import type { MessageKey } from "./en"

/**
 * Arabic (Modern Standard Arabic, console register). Identifiers, codes and values from the cell stay
 * untranslated and left-to-right inside the text. Plurals use all six Arabic forms.
 */
export const ar = {
  "app.name": "نورن",
  "graph.title": "رسم الكائنات",
  "nav.graph": "رسم الكائنات",
  "graph.open": "فتح في الرسم",
  "graph.search": "البحث عن كائن",
  "graph.closeSearch": "إغلاق البحث عن كائن",
  "graph.searchHelp": "اختر نوعاً وابحث عن كائن مسموح، أو افتح مفتاحاً دقيقاً في الرسم.",
  "graph.searchType": "نوع الكائن",
  "graph.searchKey": "يحتوي المفتاح على",
  "graph.searchPlaceholder": "تصفية المفاتيح أو إدخال مفتاح دقيق…",
  "graph.searchEmpty": "لا توجد مفاتيح مطابقة في هذه الصفحة.",
  "graph.searchPage": "يقتصر البحث على الصفحة الحالية.",
  "graph.openKey": "فتح المفتاح الدقيق",
  "graph.firstPage": "الصفحة الأولى",

  "nav.expand": "توسيع الشريط الجانبي",
  "nav.collapse": "طي الشريط الجانبي",
  "nav.controlPlane": "لوحة التحكم",
  "nav.installedApps": "التطبيقات المثبتة",
  "nav.primary": "التنقل الرئيسي",
  "nav.overview": "نظرة عامة",
  "nav.definitions": "التعريفات",
  "nav.data": "البيانات",
  "nav.explorer": "المستكشف",
  "nav.objects": "الكائنات",
  "nav.ledger": "السجل",
  "nav.apps": "التطبيقات",
  "nav.operate": "التشغيل",
  "nav.inbox": "صندوق الوارد",
  "nav.findings": "الملاحظات",
  "nav.permissions": "الصلاحيات",
  "nav.menu": "القائمة",
  "nav.closeMenu": "إغلاق القائمة",

  "shell.userMenu": "تفاصيل الجلسة",
  "shell.notConnected": "غير متصل",
  "shell.signedIn": "تم تسجيل الدخول",
  "shell.signOut": "تسجيل الخروج",
  "shell.disconnect": "قطع الاتصال",
  "shell.themeLight": "المظهر الفاتح",
  "shell.themeDark": "المظهر الداكن",
  "shell.toggleTheme": "تبديل المظهر",
  "shell.actor": "الفاعل {{actor}}",
  "shell.sessionEnded":
    "انتهت جلستك وتعذّر تجديدها، لذلك ترفض الخلية الطلبات الجديدة. تسجيل الدخول مجددًا يعيد تحميل هذه الصفحة، فانسخ أي شيء لم يُحفظ أولًا.",
  "shell.signInAgain": "تسجيل الدخول مجددًا",

  "locale.label": "اللغة",
  "locale.en": "English",
  "locale.ar": "العربية",
  "locale.digits": "الأرقام",
  "locale.digitsLatn": "0123456789",
  "locale.digitsArab": "٠١٢٣٤٥٦٧٨٩",
  "locale.savedHere": "محفوظ لك على هذا الجهاز.",

  "connect.signInTitle": "تسجيل الدخول",
  "connect.signInDescription": "استخدم حساب مؤسستك. يتحقق نورن مما يحق لك رؤيته وفعله في كل طلب.",
  "connect.sessionExpired": "انتهت جلستك وتعذّر تجديدها. سجّل الدخول مجددًا للمتابعة.",
  "connect.signInButton": "تسجيل الدخول بحساب مؤسستك",
  "connect.signInFailed": "تعذّر فتح صفحة تسجيل الدخول: {{error}}",
  "connect.callbackTitle": "جارٍ تسجيل الدخول…",
  "connect.callbackDescription": "جارٍ إكمال تسجيل الدخول مع مؤسستك.",
  "connect.callbackFailedTitle": "لم يكتمل تسجيل الدخول",
  "connect.callbackFailedDescription": "تعذّر استخدام رد مزوّد الهوية. لم يُحفظ أي شيء.",
  "connect.tryAgain": "حاول مجددًا",
  "connect.title": "الاتصال بخلية",
  "connect.description": "تقرأ لوحة التحكم خلية مستأجر واحدة وتعدّلها عبر واجهتها البرمجية، بالهوية التي يحملها رمزك.",
  "connect.cellUrl": "عنوان الخلية",
  "connect.invalidUrl": "هذا ليس عنوانًا صالحًا.",
  "connect.otherCellToken": "هذا الرمز يخص خلية أخرى. الصق رمز هذه الخلية.",
  "connect.token": "رمز الوصول",
  "connect.tokenPlaceholder": "الصق رمز وصول",
  "connect.tokenCleared": "مُسح رمز الخلية السابقة لأن العنوان يشير إلى خلية أخرى. ",
  "connect.tokenHelp": "يُحفظ في هذا التبويب فقط ويُمسح عند إغلاقه. لا يُرسل إلا إلى هذه الخلية.",
  "connect.devActor": "فاعل التطوير",
  "connect.devActorHelp": "يُرسل في الترويسة {{header}}. لا تعتدّ به إلا خلية في وضع التطوير الصريح.",
  "connect.submit": "اتصال",

  "scope.chooseTitle": "اختر النطاق",
  "scope.chooseDescription": "كل قراءة وتعديل يسمّي المؤسسة والبيئة صراحةً. متصل بـ {{cell}}.",
  "connect.signingIn": "جارٍ تسجيل الدخول",
  "connect.tokenChangedHelp":
    "مُسح رمز الخلية السابقة لأن العنوان يشير إلى خلية مختلفة. يُحفظ في علامة التبويب هذه فقط ويُمسح عند إغلاقها. ولا يُرسل إلا إلى هذه الخلية.",
  "scope.wrongCell": "الخلية غير صحيحة؟",
  "scope.changeConnection": "تغيير الاتصال",
  "scope.aCell": "خلية",
  "scope.organization": "المؤسسة",
  "scope.environment": "البيئة",
  "scope.open": "فتح النطاق",
  "scope.recent": "الأخيرة",
  "scope.switch": "تبديل النطاق",
  "scope.changeLabel": "النطاق: {{orgId}} / {{environmentId}}. تغيير النطاق",
  "shell.breadcrumb": "مسار التنقل",
  "copy.copied": "نُسخ",
  "copy.label": "نسخ",
  "copy.value": "نسخ {{value}}",
  "states.loading": "جارٍ التحميل",
  "states.credentialsRefused": "لم تقبل هذه الخلية بيانات اعتمادك",
  "states.updateConnection": "تحديث الاتصال",
  "states.unreachableHelp":
    "لم يتلقَّ الطلب أي استجابة. تأكد من تشغيل الخلية وصحة العنوان وإدراج أصل وحدة التحكم هذه ضمن الأصول المسموح بها للخلية.",
  "states.cannotRead": "لا يمكنك قراءة {{what}} في هذا النطاق",
  "states.cannotReach": "يتعذر الاتصال بـ {{url}}",
  "states.cannotLoad": "تعذر تحميل {{what}}",

  "definitions.kind.entity": "الكيانات",
  "definitions.kind.action": "الإجراءات",
  "definitions.kind.rule": "القرارات",
  "definitions.kind.mapping": "عمليات الربط",
  "definitions.kind.sourceSchema": "مخططات المصادر",
  "definitions.kind.connector": "الموصلات",
  "definitions.kind.policy": "السياسات",
  "definitions.kind.widget": "الواجهات",

  "connect.devActorFormattedHelp":
    "يُرسل في الترويسة <header>{{header}}</header>. لا تعتدّ به إلا خلية في وضع التطوير الصريح.",

  "common.refresh": "تحديث",
  "common.cancel": "إلغاء",
  "common.working": "جارٍ التنفيذ…",
  "common.previous": "السابق",
  "common.next": "التالي",
  "common.page": "الصفحة {{page}}",
  "inbox.acknowledge": "إقرار",
  "inbox.acknowledgeConfirm": "إغلاق دون إعادة الإرسال",
  "inbox.acknowledgeConsequence": "يغلق المهمة. لن يُرسل الأمر مجددًا؛ سوِّ الحالة في النظام المستهدف يدويًا إذا لزم الأمر.",
  "inbox.confirmAcknowledge": "تأكيد الإقرار",
  "inbox.release": "إتاحة إعادة المحاولة",
  "inbox.releaseConfirm": "إتاحة محاولة واحدة",
  "inbox.releaseConsequence": "أنت تقرّ بأن الأمر لم يُنفّذ في النظام المستهدف. يجوز لنورن إعادة محاولته مرة واحدة.",
  "inbox.confirmRelease": "تأكيد إتاحة إعادة المحاولة",
  "inbox.unattributedCommand": "أمر دون إجراء منسوب إليه",
  "inbox.needsReconciliation": "يحتاج إلى تسوية",
  "inbox.retryUsed": "استُخدمت إعادة المحاولة",
  "inbox.status.failed": "فشل",
  "inbox.status.dispatching": "قيد الإرسال",
  "inbox.status.retrying": "قيد إعادة المحاولة",
  "inbox.status.resolved": "تمت التسوية",
  "inbox.status.acknowledged": "أُقِرّ",
  "inbox.status.released": "أُتيحت إعادة المحاولة",
  "inbox.resolvedBy": "بواسطة {{name}}",
  "inbox.recoveryRetryUsed": "استُخدمت بالفعل محاولة الاسترداد الوحيدة لهذه المهمة",
  "inbox.title": "الأوامر الفاشلة",
  "inbox.description":
    "أوامر صادرة انتهت بالفشل. اتخذ قرارًا لكل منها: أقرّ لإغلاقها، أو أتِح إعادة المحاولة لتؤكد أنها لم تُنفّذ وتسمح بمحاولة واحدة.",
  "inbox.taskState": "حالة المهمة",
  "inbox.needsDecision": "تحتاج إلى قرار",
  "inbox.resolvedInFlight": "تمت تسويتها أو قيد التنفيذ",
  "inbox.page": "الصفحة {{page}}",
  "inbox.commandTasks": "مهام الأوامر",
  "inbox.nothingNeedsDecision": "لا شيء يحتاج إلى قرار",
  "inbox.nothingNeedsDecisionPage": "لا شيء يحتاج إلى قرار في هذه الصفحة",
  "inbox.nothingResolved": "لا شيء تمت تسويته أو قيد التنفيذ",
  "inbox.nothingResolvedPage": "لا شيء تمت تسويته أو قيد التنفيذ في هذه الصفحة",
  "inbox.moreTasks": "توجد مهام أخرى في الصفحة التالية.",
  "inbox.allResolved": "كل أمر صادر نجح أو تمت تسويته بالفعل.",
  "inbox.resolvedDescription":
    "تظهر هنا المهام المُقرّ بها والمُتاحة لإعادة المحاولة مع مَن سوّاها، إلى جانب الأوامر التي لا تزال قيد الإرسال أو إعادة المحاولة.",
  "inbox.pageCounts_zero": "الأعداد تخص هذه الصفحة التي لا تضم أي مهام.",
  "inbox.pageCounts_one": "الأعداد تخص هذه الصفحة التي تضم مهمة واحدة على الأكثر.",
  "inbox.pageCounts_two": "الأعداد تخص هذه الصفحة التي تضم مهمتين على الأكثر.",
  "inbox.pageCounts_few": "الأعداد تخص هذه الصفحة التي تضم {{count}} مهام على الأكثر.",
  "inbox.pageCounts_many": "الأعداد تخص هذه الصفحة التي تضم {{count}} مهمة على الأكثر.",
  "inbox.pageCounts_other": "الأعداد تخص هذه الصفحة التي تضم {{count}} مهمة على الأكثر.",
  "inbox.humanApprovalsDeferred": "الموافقات البشرية ومهام العمل لم تُوحّد هنا بعد (#3071).",
  "findings.classification.integrity": "سلامة البيانات",
  "findings.classification.integrityHint":
    "قيد لسلامة البيانات: تُرفض الأوامر التي قد تنتهكه؛ وتُسجّل بيانات المصدر المرصودة التي تنتهكه كملاحظة.",
  "findings.classification.quality": "الجودة",
  "findings.classification.qualityHint": "متطلب للجودة: لا يرفض أي أمر؛ ويُسجّل كل انتهاك كملاحظة.",
  "findings.classification.builtin": "فحص مدمج",
  "findings.classification.builtinHint":
    "قاعدة يطبقها نورن بنفسه، مثل الصلاحية الزمنية أو مسارات دورة الحياة أو عزل الهوية.",
  "findings.classification.unverified": "غير متحقق منها",
  "findings.classification.unverifiedHint":
    "تعذّر على الخلية التحقق من القاعدة وراء هذه الملاحظة، لذا فإن تصنيفها غير معروف.",
  "findings.ruleBuiltIn": "مدمج · {{id}}",
  "findings.unpinnedVersion": "غير مثبّت الإصدار (سجل قديم)",
  "findings.outcome.notSatisfied": "كانت نتيجة التعبير false.",
  "findings.outcome.nonBoolean": "أعاد التعبير {{actual}} بدلًا من قيمة منطقية.",
  "findings.outcome.evaluationFailed": "تعذّر تقييم التعبير: {{reason}}",
  "findings.outcome.noPath": "رُصد {{property}} = {{state}} دون مسار معلن لدورة الحياة.",
  "findings.outcome.noPathFrom": "رُصد {{property}} = {{state}} من {{from}} دون مسار معلن لدورة الحياة.",
  "findings.outcome.multiplePaths": "رُصد {{property}} = {{state}} مع أكثر من مسار معلن يحقق أقصر طول.",
  "findings.outcome.multiplePathsFrom": "رُصد {{property}} = {{state}} من {{from}} مع أكثر من مسار معلن يحقق أقصر طول.",
  "findings.outcome.invalidTemporal": "{{property}} = {{value}} ليست قيمة زمنية صالحة: {{reason}}",
  "findings.outcome.identityIsolation": "عُزل صف الهوية ({{code}}): {{detail}}",
  "findings.lastSeenDate": "آخر ظهور {{date}}",
  "findings.lastSeenNow": "آخر ظهور الآن",
  "findings.lastSeenMinutes_zero": "آخر ظهور الآن",
  "findings.lastSeenMinutes_one": "آخر ظهور قبل دقيقة",
  "findings.lastSeenMinutes_two": "آخر ظهور قبل دقيقتين",
  "findings.lastSeenMinutes_few": "آخر ظهور قبل {{count}} دقائق",
  "findings.lastSeenMinutes_many": "آخر ظهور قبل {{count}} دقيقة",
  "findings.lastSeenMinutes_other": "آخر ظهور قبل {{count}} دقيقة",
  "findings.lastSeenHours_zero": "آخر ظهور الآن",
  "findings.lastSeenHours_one": "آخر ظهور قبل ساعة",
  "findings.lastSeenHours_two": "آخر ظهور قبل ساعتين",
  "findings.lastSeenHours_few": "آخر ظهور قبل {{count}} ساعات",
  "findings.lastSeenHours_many": "آخر ظهور قبل {{count}} ساعة",
  "findings.lastSeenHours_other": "آخر ظهور قبل {{count}} ساعة",
  "findings.lastSeenDays_zero": "آخر ظهور اليوم",
  "findings.lastSeenDays_one": "آخر ظهور قبل يوم",
  "findings.lastSeenDays_two": "آخر ظهور قبل يومين",
  "findings.lastSeenDays_few": "آخر ظهور قبل {{count}} أيام",
  "findings.lastSeenDays_many": "آخر ظهور قبل {{count}} يومًا",
  "findings.lastSeenDays_other": "آخر ظهور قبل {{count}} يوم",
  "findings.any": "الكل",
  "findings.firstSeen": "أول ظهور {{date}}",
  "findings.hideEvidence": "إخفاء الأدلة",
  "findings.evidence": "الأدلة",
  "findings.provenance":
    "المصدر <sourceValue>{{source}}</sourceValue> حُوّل بالربط <mapping>{{mapping}}</mapping>، وسُجّل {{recordedAt}}",
  "findings.provenanceObservations":
    "المصدر <sourceValue>{{source}}</sourceValue> حُوّل بالربط <mapping>{{mapping}}</mapping>، وسُجّل {{recordedAt}} · الرصد {{observations}}",
  "findings.noLineage": "لم يُسجّل مسار بيانات المصدر لهذه الملاحظة.",
  "findings.title": "ملاحظات جودة البيانات",
  "findings.description":
    "أدلة على انتهاك البيانات لقاعدة معلنة أو فحص مدمج. ترفض قيود <integrity>سلامة البيانات</integrity> الأوامر، لذا تأتي ملاحظاتها من بيانات المصدر المرصودة؛ أما متطلبات <quality>الجودة</quality> فلا ترفض أبدًا وتسجّل دائمًا. تُحجب الملاحظات عن الكائنات التي لا يمكنك قراءتها.",
  "findings.filterStatus": "الحالة",
  "findings.filterSeverity": "الخطورة",
  "findings.ruleId": "معرّف القاعدة",
  "findings.objectType": "نوع الكائن",
  "findings.subjectObjectType": "نوع الكائن المعني",
  "findings.objectKey": "مفتاح الكائن",
  "findings.subjectKey": "مفتاح الكائن المعني",
  "findings.dataQualityFindings": "ملاحظات جودة البيانات",
  "findings.noMatches": "لا توجد ملاحظات تطابق هذه المرشحات",
  "findings.noneVisible": "لا توجد ملاحظات يمكنك رؤيتها",
  "findings.clearFilter": "أزل مرشحًا لتوسيع البحث.",
  "findings.noFindingsDescription":
    "لم تنتهك أي بيانات مرئية قاعدة معلنة أو فحصًا مدمجًا. تُحجب الملاحظات عن الكائنات خارج صلاحية قراءتك بدلًا من عدّها.",

  "common.none": "لا شيء",
  "common.all": "الكل",
  "common.tenant": "المستأجر",
  "common.registry": "السجل المرجعي",
  "common.noneDeclared": "لا شيء مُعلَن.",
  "overview.title": "مجموعة التعريفات المثبّتة",
  "overview.description": "ما قبلته هذه الخلية لـ {{orgId}} / {{environmentId}}، كما يشهد عليه إيصال الفاحص.",
  "overview.cell": "الخلية",
  "overview.setVersion": "إصدار المجموعة",
  "overview.receipt": "الإيصال",
  "overview.registryBase": "أساس السجل المرجعي",
  "overview.noneSelected": "لم يُحدّد أي منها",
  "overview.unreadableEntries": "إدخالات غير قابلة للقراءة",
  "overview.unreadable_zero":
    "لا توجد إدخالات مُقدَّمة بصيغة غير أغلفة العناصر لتُعرض. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.unreadable_one":
    "إدخال مُقدَّم واحد ليس غلاف عنصر ولا يُعرض. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.unreadable_two":
    "إدخالان مُقدَّمان ليسا أغلفة عناصر ولا يُعرضان. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.unreadable_few":
    "{{count}} إدخالات مُقدَّمة ليست أغلفة عناصر ولا تُعرض. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.unreadable_many":
    "{{count}} إدخالًا مُقدَّمًا ليست أغلفة عناصر ولا تُعرض. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.unreadable_other":
    "{{count}} إدخال مُقدَّم ليست أغلفة عناصر ولا تُعرض. قد تختلف الخلية ووحدة التحكم هذه على إصدار العقد.",
  "overview.checkerFindings": "ملاحظات الفاحص",
  "overview.nonError_zero": "لا ملاحظات غير الأخطاء",
  "overview.nonError_one": "ملاحظة واحدة غير خطأ",
  "overview.nonError_two": "ملاحظتان غير أخطاء",
  "overview.nonError_few": "{{count}} ملاحظات غير أخطاء",
  "overview.nonError_many": "{{count}} ملاحظة غير خطأ",
  "overview.nonError_other": "{{count}} ملاحظة غير خطأ",
  "overview.byKind": "حسب النوع",
  "overview.kind": "النوع",
  "overview.total": "الإجمالي",
  "definitions.what": "التعريفات",
  "definitions.emptyTitle": "لا توجد تعريفات مثبّتة",
  "definitions.emptyDescription":
    "المجموعة المقبولة في هذا النطاق فارغة. تأتي التعريفات من تثبيت خاضع للفحص (<route>PUT /v1/defs</route>) أو إصدار من السجل المرجعي يُحدّد عند التهيئة.",
  "definitions.layer": "الطبقة",
  "definitions.registryReadOnly": "أساس السجل المرجعي، للقراءة فقط",
  "definitions.setVersion": "إصدار مجموعة التعريفات المثبّتة",
  "definitions.installedVersion": "مجموعة v{{version}}",
  "definitions.refresh": "تحديث التعريفات",
  "definitions.filter": "تصفية {{kind}}",
  "definitions.emptyKindTitle": "لا توجد {{kind}} في هذا النطاق",
  "definitions.emptyKindDescription":
    "لم يُقبل أي عنصر من النوع <kind>{{kind}}</kind> لـ {{orgId}} / {{environmentId}}.",
  "definitions.noMatches": "لا شيء يطابق هذه التصفية.",
  "definitions.select": "حدّد أحد عناصر {{kind}} لقراءة تعريفه المعتمد.",
  "definitionDetail.what": "هذا التعريف",
  "definitionDetail.notInstalledTitle": "ليس في المجموعة المثبّتة",
  "definitionDetail.notInstalledDescription":
    "<artifact>{{artifactId}}</artifact> ليس عنصرًا مقبولًا من النوع {{kind}} في المجموعة v{{version}}. ربما أُزيل في تثبيت لاحق.",
  "definitionDetail.editDecisionTable": "تحرير جدول القرار",
  "definitionDetail.namespace": "مساحة الأسماء {{namespace}}",
  "definitionDetail.registryRelease":
    "أساس السجل المرجعي للقراءة فقط، ومصدره <release>{{release}}</release>؛ غيّره بتحديد إصدار آخر بدلًا من تحريره هنا.",
  "definitionDetail.registryReleases":
    "أساس السجل المرجعي للقراءة فقط، ومصدره إصدارات السجل المرجعي المحدّدة؛ غيّره بتحديد إصدار آخر بدلًا من تحريره هنا.",
  "definitionDetail.summary": "ملخّص",
  "definitionDetail.canonicalJson": "JSON المعتمد",
  "definitionDetail.referencedBy": "تشير إليه",
  "definitionDetail.noReferences": "لا يشير أي تعريف مثبّت آخر إلى هذا التعريف.",
  "definitionSummary.sharedPropertyTypes": "أنواع الخصائص المشتركة",
  "definitionSummary.name": "الاسم",
  "definitionSummary.type": "النوع",
  "definitionSummary.description": "الوصف",
  "definitionSummary.extends": "يمتد من",
  "definitionSummary.implements": "يطبّق",
  "definitionSummary.properties": "الخصائص",
  "definitionSummary.property": "الخاصية",
  "definitionSummary.constraints": "القيود",
  "definitionSummary.value": "القيمة",
  "definitionSummary.computedReadOnly": "محسوبة · للقراءة فقط",
  "definitionSummary.default": "افتراضي",
  "definitionSummary.links": "الروابط",
  "definitionSummary.link": "الرابط",
  "definitionSummary.target": "الهدف",
  "definitionSummary.cardinality": "التعددية",
  "definitionSummary.inverse": "العكسي",
  "definitionSummary.required": " · مطلوب",
  "definitionSummary.keys": "المفاتيح",
  "definitionSummary.key": "المفتاح",
  "definitionSummary.lifecycle": "دورة الحياة · {{property}}",
  "definitionSummary.transition": "الانتقال",
  "definitionSummary.from": "من",
  "definitionSummary.to": "إلى",
  "definitionSummary.legacyDecision":
    "قرار RuleIR {{version}}. جدوله أو قيمته الحرفية في JSON المعتمد؛ يغطي هذا الملخّص الرسوم البيانية للقرارات في 2.0.",
  "definitionSummary.rule": "القاعدة",
  "definitionSummary.form": "الصيغة",
  "definitionSummary.ruleForm": "RuleIR {{version}} · العقد <contract>{{contract}}</contract>",
  "definitionSummary.triggers": "المشغّلات",
  "definitionSummary.on": "عند",
  "definitionSummary.detail": "التفصيل",
  "definitionSummary.slice": "الشريحة",
  "definitionSummary.decisionGraph": "الرسم البياني للقرار",
  "definitionSummary.node": "العقدة",
  "definitionSummary.content": "المحتوى",
  "definitionSummary.tableNode_zero":
    "{{count}} صفوف · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.tableNode_one":
    "صف واحد · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.tableNode_two":
    "صفّان · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.tableNode_few":
    "{{count}} صفوف · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.tableNode_many":
    "{{count}} صفًا · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.tableNode_other":
    "{{count}} صف · {{inputCount}} مدخلات · {{outputCount}} مخرجات · سياسة المطابقة {{hitPolicy}}",
  "definitionSummary.expressionNode_zero": "لا تعبيرات",
  "definitionSummary.expressionNode_one": "تعبير واحد",
  "definitionSummary.expressionNode_two": "تعبيران",
  "definitionSummary.expressionNode_few": "{{count}} تعبيرات",
  "definitionSummary.expressionNode_many": "{{count}} تعبيرًا",
  "definitionSummary.expressionNode_other": "{{count}} تعبير",
  "definitionSummary.input": "المدخلات",
  "definitionSummary.field": "الحقل",
  "definitionSummary.preconditions": "الشروط المسبقة",
  "definitionSummary.effect": "الأثر",
  "definitionSummary.transitionEffect":
    " يُطلق <transition>{{transition}}</transition> على <object>{{object}}</object>.{{lifecycle}}",
  "definitionSummary.commands": "الأوامر",
  "definitionSummary.connector": "الموصّل",
  "definitionSummary.operation": "العملية",
  "definitionSummary.writes": "عمليات الكتابة",
  "definitionSummary.change": "التغيير",
  "definitionSummary.mappingDescription":
    "مُعلَن من مخطط المصدر <schema>{{schema}}</schema> <version>{{version}}</version>. هذه هي التعبيرات المُعلَنة، وليست مسار البيانات المسجّل.",
  "definitionSummary.expression": "التعبير",
  "definitionSummary.stateProperty": "{{property}} (حالة)",
  "definitionSummary.source": "<system>{{system}}</system> {{version}} في <instance>{{instance}}</instance>.",
  "definitionSummary.sourceObserved":
    "<system>{{system}}</system> {{version}} في <instance>{{instance}}</instance>، لوحظ في {{observedAt}}.",
  "definitionSummary.fields": "الحقول",
  "definitionSummary.dataset": "مجموعة البيانات",
  "definitionSummary.nativeType": "النوع الأصلي",
  "definitionSummary.candidate": "المرشّح",
  "definitionSummary.roleCondition": "الدور ∈ {{roles}}",
  "definitionSummary.relationshipCondition": "{{from}} {{role}} الجهة المصادَق عليها",
  "definitionSummary.scopeMatch": "تطابق {{dimensions}}",
  "definitionSummary.scopeUnspecified": "النطاق غير محدّد",
  "definitionSummary.conjunction": "{{left}} و{{right}}",
  "definitionSummary.scopeOnly": "{{scope}} (النطاق فقط)",
  "definitionSummary.policyDescription":
    "قواعد AccessIR كما أُعلِنت. تُحوّلها Norn إلى Cedar؛ وتعتمد صلاحية أي شخص للتصرف أيضًا على القدرات والنطاق والتفويض.",
  "definitionSummary.rules": "القواعد",
  "definitionSummary.resource": "المورد",
  "definitionSummary.when": "متى",
  "definitionSummary.noScalarFields": "لا توجد حقول ذات قيم بسيطة.",
  "definitionSummary.structuredFields": "الحقول ذات البنية المركّبة ({{fields}}) موجودة في JSON المعتمد.",
  "lifecycle.diagram_zero": "مخطط دورة الحياة، لا حالات",
  "lifecycle.diagram_one": "مخطط دورة الحياة، حالة واحدة",
  "lifecycle.diagram_two": "مخطط دورة الحياة، حالتان",
  "lifecycle.diagram_few": "مخطط دورة الحياة، {{count}} حالات",
  "lifecycle.diagram_many": "مخطط دورة الحياة، {{count}} حالة",
  "lifecycle.diagram_other": "مخطط دورة الحياة، {{count}} حالة",

  "explorer.types": "الأنواع",
  "explorer.lineage": "مسار البيانات",
  "explorer.layingOutGraph": "جارٍ ترتيب الرسم البياني",
  "explorer.noObjectTypes": "لا توجد أنواع كائنات مثبتة",
  "explorer.typeGraphDescription": "يعرض رسم الأنواع أنواع الكائنات والواجهات وروابطها بعد تثبيت تعريفات الكيانات.",
  "explorer.showingRegistryBase": "تُعرض قاعدة السجل المركزي",
  "explorer.includeRegistryBase": "تضمين قاعدة السجل المركزي",
  "explorer.details": "تفاصيل {{name}}",
  "explorer.registryBase": "قاعدة السجل المركزي",
  "explorer.tenant": "المستأجر",
  "explorer.closeDetails": "إغلاق التفاصيل",
  "explorer.openDefinition": "فتح التعريف",
  "explorer.browseObjects": "استعراض الكائنات",
  "explorer.noMappings": "لا توجد تحويلات بيانات مثبتة",
  "explorer.lineageDescription":
    "يعرض مسار البيانات المعلن مجموعات بيانات المصدر عبر MappingIR إلى أنواع الكائنات. ثبّت تحويل بيانات ومخطط مصدره لعرضه هنا.",
  "explorer.source": "المصدر",
  "explorer.mappingDetails": "تفاصيل تحويل البيانات",
  "explorer.declaredExpressions": "تعبيرات معلنة. لمعرفة ما أنتج قيمة فعلًا، افتح الكائن واقرأ أسبابه المسجلة.",
  "explorer.lifecycle": "دورة الحياة",
  "explorer.openMappingDefinition": "فتح تعريف تحويل البيانات",
  "explorer.browseType": "استعراض {{name}}",
  "graph.interface": "واجهة",
  "graph.objectType": "نوع الكائن",
  "graph.addedByExtension": "أضافها الامتداد {{name}}",
  "graph.declaredByDefinitions": "معلن في التعريفات",
  "graph.recordedInLedger": "مسجل في السجل",
  "graph.noOwnProperties": "لا توجد خصائص خاصة",
  "graph.sourceDataset": "{{system}} · مجموعة بيانات المصدر",
  "graph.namespacedObjectType": "{{namespace}} · نوع الكائن",
  "graph.unmapped": "بلا تحويل بيانات",
  "objects.commandFailuresDescription": "أوامر فاشلة تحتاج إلى متابعة بشرية.",
  "objects.description":
    "الكائنات المعتمدة بحسب النوع، كما يُسمح لهذه الهوية بقراءتها. الصفحات محدودة؛ لا يُحمّل رسم المثيلات كاملًا.",
  "objects.objectTypes": "أنواع الكائنات",
  "objects.registryBaseType": "نوع من قاعدة السجل المركزي",
  "objects.system": "النظام",
  "objects.typeObjects": "كائنات {{name}}",
  "objects.noReadableObjects": "لا توجد كائنات {{name}} يمكنك قراءتها",
  "objects.emptyDescription":
    "إما لا توجد كائنات معتمدة في {{orgId}} / {{environmentId}}، أو لا تظهر أي منها لهذه الهوية. تصل الكائنات عبر الإجراءات والقواعد ورصد المصادر.",
  "objects.version": "الإصدار",
  "objects.deletedInSource": "محذوف في المصدر",
  "objects.pageSummary": "الصفحة {{page}} · حتى {{limit}} في الصفحة",
  "objects.readAs": "مقروء بوصفه {{name}}",
  "objects.why": "الأسباب",
  "objects.values": "القيم",
  "objects.json": "JSON",
  "objects.evidenceReadFailed": "تعذّرت قراءة الأدلة المسجلة، لذلك لا يعرض أي حقل مصدره.",
  "objects.evidenceVersionMismatch":
    "قُرئت الأدلة المسجلة للإصدار v{{evidenceVersion}}؛ وهذا الكائن بالإصدار v{{objectVersion}}. تُخفى الأدلة حتى يُقرأ كلاهما بالإصدار نفسه.",
  "objects.readBothAgain": "قراءة كليهما مجددًا",
  "objects.partialHistory": "يُعرض السجل الحديث الذي تغطيه هذه القراءة؛ الخطوات الأقدم خارج ميزانية القراءة ويمكن فتحها من «لماذا».",
  "objects.noRecordedSource": "لا يوجد مصدر مسجل",
  "objects.historyHidden": "السجل مخفي بموجب السياسة",
  "objects.via": "عبر",
  "objects.recordedAndObservedAt": "مسجل {{recordedAt}}، مرصود {{observedAt}}",
  "objects.recordedAt": "مسجل {{recordedAt}}",
  "objects.evidenceCommit": "· اعتماد {{commit}} · v{{version}}",
  "objects.history": "سجل هذا الكائن",
  "objects.noRecordedHistory": "لا يظهر سجل مسجل",
  "objects.noRecordedHistoryDescription": "لم تسجل الخلية أسبابًا لهذا الإصدار يُسمح لهذه الهوية بقراءتها.",
  "objects.recordedSteps": "الخطوات المسجلة",
  "objects.steps": "الخطوات",
  "objects.historyTruncated": "السجل الأقدم غير معروض: هذه هي الخطوات الحديثة التي تغطيها هذه القراءة.",
  "objects.openInbox": "فتح صندوق الوارد",
  "objects.stepDecision": "قرار {{name}}",
  "objects.stepAction": "إجراء {{name}}",
  "objects.stepObserved": "رُصد {{name}}",
  "objects.stepTransitionStates": "انتقال {{name}} · {{from}} → {{to}}",
  "objects.stepTransition": "انتقال {{name}}",
  "objects.stepTimerScheduledFired": "المؤقت {{name}} مجدول، نُفّذ",
  "objects.stepTimerScheduled": "المؤقت {{name}} مجدول",
  "objects.stepTimerFired": "نُفّذ المؤقت {{name}}",
  "objects.stepCommandEnqueued": "أُضيف الأمر {{name}} إلى قائمة الانتظار",
  "objects.stepCommandResult": "نتيجة الأمر {{name}}",
  "objects.matchedRow": "الصف {{row}}",
  "objects.openObject": "فتح الكائن",
  "neighborhood.loadingLinks": "جارٍ تحميل الروابط",
  "neighborhood.moreLinksMayExist": "قد توجد روابط أخرى",
  "neighborhood.notExpanded": "لم يُوسّع",
  "neighborhood.committedLinks": "الروابط المعتمدة، كما يُسمح لك بقراءتها",
  "neighborhood.selectedObject": "الكائن المحدد",
  "neighborhood.showLinks": "عرض الروابط",
  "neighborhood.retry": "إعادة المحاولة",
  "neighborhood.loadMoreLinks": "تحميل مزيد من الروابط",
  "neighborhood.moreLinksDescription":
    "قد توجد روابط أخرى. قد تكون الصفحة قصيرة أو فارغة بينما لا يزال لدى الخلية المزيد لفحصه.",
  "neighborhood.scanLimit": "بلغت الخلية حد الفحص لروابط هذا الكائن. تتابع إعادة المحاولة من حيث توقف الفحص.",
  "ledger.eventFallback": "حدث",
  "ledger.verifiedHeadHash": "بصمة رأس السجل المتحقق منها {{hash}}",
  "ledger.head": "الرأس",
  "ledger.theLedger": "السجل",
  "ledger.empty": "السجل فارغ",
  "ledger.nothingAfterPosition": "لا شيء بعد هذا الموضع",
  "ledger.receiptReset": "أُعيد الضبط منذ هذا الإجراء",
  "ledger.receiptResetHelp": "أُعيد ضبط الخلية أو استعادتها، أو أنك تعرض خلية أخرى. لم يعد الإيصال الأصلي في سجلها. لن يفتح الرقم المُعاد استخدامه إجراءً آخر.",
  "ledger.actionRecorded": "سُجّل الإجراء",
  "ledger.actionRecordedHelp": "اعتمد هذا الإجراء إيصالًا متحققًا منه دون أحداث أعمال.",
  "ledger.emptyDescription": "يضيف كل أثر عمل معتمد وكل تثبيت تعريف قيدًا مرتبطًا بسلسلة بصمات هنا.",
  "ledger.seq": "التسلسل",
  "ledger.commit": "الاعتماد",
  "ledger.event": "الحدث",
  "ledger.subject": "الموضوع",
  "ledger.world": "العالم",
  "ledger.hash": "البصمة",
  "ledger.hashLabel": "البصمة",
  "ledger.prevLabel": "السابق",
  "ledger.range": "#{{first}}–#{{last}} من {{head}}",
  "ledger.afterPosition": "بعد #{{after}}",
  "ledger.back": "رجوع",
  "ledger.nextPage": "التالي {{count}}",
  "ledger.latest": "الأحدث",
  "explorer.includeRegistryBaseMore_zero": "تضمين قاعدة السجل المركزي · لا أنواع إضافية",
  "explorer.includeRegistryBaseMore_one": "تضمين قاعدة السجل المركزي · نوع إضافي واحد",
  "explorer.includeRegistryBaseMore_two": "تضمين قاعدة السجل المركزي · نوعان إضافيان",
  "explorer.includeRegistryBaseMore_few": "تضمين قاعدة السجل المركزي · {{count}} أنواع إضافية",
  "explorer.includeRegistryBaseMore_many": "تضمين قاعدة السجل المركزي · {{count}} نوعًا إضافيًا",
  "explorer.includeRegistryBaseMore_other": "تضمين قاعدة السجل المركزي · {{count}} نوع إضافي",
  "explorer.typeGraphCount_zero": "لا أنواع · الروابط: {{edgeCount}}",
  "explorer.typeGraphCount_one": "نوع واحد · الروابط: {{edgeCount}}",
  "explorer.typeGraphCount_two": "نوعان · الروابط: {{edgeCount}}",
  "explorer.typeGraphCount_few": "{{count}} أنواع · الروابط: {{edgeCount}}",
  "explorer.typeGraphCount_many": "{{count}} نوعًا · الروابط: {{edgeCount}}",
  "explorer.typeGraphCount_other": "{{count}} نوع · الروابط: {{edgeCount}}",
  "graph.moreProperties_zero": "+لا خصائص أخرى",
  "graph.moreProperties_one": "+خاصية أخرى واحدة",
  "graph.moreProperties_two": "+خاصيتان أخريان",
  "graph.moreProperties_few": "+{{count}} خصائص أخرى",
  "graph.moreProperties_many": "+{{count}} خاصية أخرى",
  "graph.moreProperties_other": "+{{count}} خاصية أخرى",
  "objects.deletedLinkTargets_zero": "لم تُحذف وجهات روابط في مصدرها؛ تبقى الروابط مع علامة.",
  "objects.deletedLinkTargets_one": "حُذفت وجهة رابط واحدة في مصدرها؛ تبقى الروابط مع علامة.",
  "objects.deletedLinkTargets_two": "حُذفت وجهتا رابط في مصدرهما؛ تبقى الروابط مع علامة.",
  "objects.deletedLinkTargets_few": "حُذفت {{count}} وجهات روابط في مصدرها؛ تبقى الروابط مع علامة.",
  "objects.deletedLinkTargets_many": "حُذفت {{count}} وجهة رابط في مصدرها؛ تبقى الروابط مع علامة.",
  "objects.deletedLinkTargets_other": "حُذفت {{count}} وجهة رابط في مصدرها؛ تبقى الروابط مع علامة.",
  "objects.upstreamFacts_zero": "· لا وقائع سابقة",
  "objects.upstreamFacts_one": "· واقعة سابقة واحدة",
  "objects.upstreamFacts_two": "· واقعتان سابقتان",
  "objects.upstreamFacts_few": "· {{count}} وقائع سابقة",
  "objects.upstreamFacts_many": "· {{count}} واقعة سابقة",
  "objects.upstreamFacts_other": "· {{count}} واقعة سابقة",
  "objects.failedCommands_zero": "لا أوامر فاشلة تحتاج إلى قرار.",
  "objects.failedCommands_one": "أمر فاشل واحد يحتاج إلى قرار.",
  "objects.failedCommands_two": "أمران فاشلان يحتاجان إلى قرار.",
  "objects.failedCommands_few": "{{count}} أوامر فاشلة تحتاج إلى قرار.",
  "objects.failedCommands_many": "{{count}} أمرًا فاشلًا يحتاج إلى قرار.",
  "objects.failedCommands_other": "{{count}} أمر فاشل يحتاج إلى قرار.",
  "neighborhood.withheldLinks_zero": "الكائنات: {{objectCount}} · لا روابط محذوفة من الرسم (الحد: {{limit}} كائنًا)",
  "neighborhood.withheldLinks_one": "الكائنات: {{objectCount}} · رابط واحد لم يُرسم (الحد: {{limit}} كائنًا)",
  "neighborhood.withheldLinks_two": "الكائنات: {{objectCount}} · رابطان لم يُرسما (الحد: {{limit}} كائنًا)",
  "neighborhood.withheldLinks_few": "الكائنات: {{objectCount}} · {{count}} روابط لم تُرسم (الحد: {{limit}} كائنًا)",
  "neighborhood.withheldLinks_many": "الكائنات: {{objectCount}} · {{count}} رابطًا لم يُرسم (الحد: {{limit}} كائنًا)",
  "neighborhood.withheldLinks_other": "الكائنات: {{objectCount}} · {{count}} رابط لم يُرسم (الحد: {{limit}} كائنًا)",
  "neighborhood.objectCount_zero": "لا كائنات",
  "neighborhood.objectCount_one": "كائن واحد",
  "neighborhood.objectCount_two": "كائنان",
  "neighborhood.objectCount_few": "{{count}} كائنات",
  "neighborhood.objectCount_many": "{{count}} كائنًا",
  "neighborhood.objectCount_other": "{{count}} كائن",
  "neighborhood.allLinksShown_zero": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",
  "neighborhood.allLinksShown_one": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",
  "neighborhood.allLinksShown_two": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",
  "neighborhood.allLinksShown_few": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",
  "neighborhood.allLinksShown_many": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",
  "neighborhood.allLinksShown_other": "تُعرض كل الروابط المسموح لك بقراءتها ({{count}}).",

  "graph.source": "المصدر",

  "permissions.conjunct.scope": "النطاق",
  "permissions.conjunct.scopeChecks": "يسمّي الطلب مؤسسة هذه الخلية وبيئتها، وتنتمي الجهة المصادَق عليها إليهما.",
  "permissions.conjunct.capability": "<conjunction>و</conjunction>القدرة",
  "permissions.conjunct.capabilityChecks": "تحمل الجهة المصادَق عليها القدرة المحددة ضمن النطاق لهذا الإجراء.",
  "permissions.conjunct.delegation": "<conjunction>و</conjunction>التفويض",
  "permissions.conjunct.delegationChecks":
    "تتصرف الجهة المصادَق عليها مباشرةً، أو عبر موافقة متحقق منها على أتمتة شخصية.",
  "permissions.conjunct.management": "<conjunction>و</conjunction>الإدارة",
  "permissions.conjunct.managementChecks": "تسمح عمليات الهوية والتفويض التي يديرها المضيف بهذا التغيير.",
  "permissions.conjunct.access": "<conjunction>و</conjunction>قواعد الوصول",
  "permissions.conjunct.accessChecks":
    "تسمح قواعد AccessIR المقبولة، والمترجمة إلى Cedar، بهذا الإجراء على هذا المورد.",
  "permissions.outcome.allow": "يسمح",
  "permissions.outcome.deny": "يرفض",
  "permissions.outcome.error": "خطأ، يرفض",
  "permissions.outcome.notEvaluated": "لم يُبلَغ",
  "permissions.membership.role": "دور",
  "permissions.membership.group": "مجموعة",
  "permissions.membership.businessUnit": "وحدة أعمال",
  "permissions.membership.always": "دائمًا",
  "permissions.membership.until": "حتى {{date}}",
  "permissions.membership.from": "من {{date}}",
  "permissions.membership.validityRange": "{{from}} → {{until}}",
  "permissions.description":
    "مَن يمكنه فعل ماذا، ولماذا. تأتي كل إجابة من نظام التفويض في الخلية نفسها. تعرض لوحة التحكم الإجابة فقط ولا تتخذ أي قرار بنفسها.",
  "permissions.whoCanDoWhat": "مَن يمكنه فعل ماذا",
  "permissions.accessRules": "قواعد الوصول",
  "permissions.people": "الأشخاص",
  "permissions.explain.question": "سؤال عن صلاحية",
  "permissions.explain.principal": "الجهة المصادَق عليها",
  "permissions.explain.otherPrincipal": "يتطلب شرح صلاحية جهة أخرى norn.authz.explain.",
  "permissions.explain.selfPrincipal": "أنت، كما ترى الخلية هذا الاتصال.",
  "permissions.explain.may": "يجوز له",
  "permissions.explain.resourceType": "نوع المورد",
  "permissions.explain.resourceKey": "مفتاح المورد",
  "permissions.explain.keyPlaceholder": "المفتاح",
  "permissions.explain.actionInput": "مدخلات الإجراء (اختياري)",
  "permissions.explain.notJson": "ليست JSON: {{error}}",
  "permissions.explain.inputHelp": "مطلوبة عندما يعتمد هدف الإجراء أو قيد عضوية على مدخلاته.",
  "permissions.explain.noReadInput": "القراءة لا تتطلب مدخلات.",
  "permissions.explain.throughDelegation": "عبر تفويض (اختياري)",
  "permissions.explain.delegationIdPlaceholder": "معرّف التفويض",
  "permissions.explain.delegationHelp": "يحدّد الوكيل التفويض هنا عندما يطلب شرح قراءته أو إجرائه المفوّض.",
  "permissions.explain.definitionsRefused":
    "تعذّرت قراءة التعريفات ({{code}})، لذا لا تُقترح الإجراءات والأنواع. اكتبها بدقة؛ وستظل الخلية تشرح ما يجوز لك فعله.",
  "permissions.explain.definitionsUnavailable":
    "تعذّرت قراءة التعريفات، لذا لا تُقترح الإجراءات والأنواع. اكتبها بدقة؛ وستظل الخلية تشرح ما يجوز لك فعله.",
  "permissions.explain.submit": "شرح",
  "permissions.explain.snapshotQuestion": "سؤال عن الحالة الحالية. لا يُنفّذ شيء ولا يتغير شيء.",
  "permissions.explain.thisQuestion": "هذا السؤال عن الصلاحية",
  "permissions.explain.explanation": "شرح الصلاحية",
  "permissions.explain.allowed": "مسموح",
  "permissions.explain.denied": "مرفوض",
  "permissions.explain.allowedSentence":
    "يجوز لـ <principalValue>{{principal}}</principalValue> تنفيذ <actionValue>{{action}}</actionValue> على <resourceValue>{{resource}}</resourceValue>.",
  "permissions.explain.deniedSentence":
    "لا يجوز لـ <principalValue>{{principal}}</principalValue> تنفيذ <actionValue>{{action}}</actionValue> على <resourceValue>{{resource}}</resourceValue>.",
  "permissions.explain.stableReasonCode": "رمز سبب ثابت",
  "permissions.explain.checksOrder": "الفحوص بالترتيب الذي تجريه الخلية",
  "permissions.explain.permittedBy": "تسمح به",
  "permissions.explain.determinedBy": "تحدده",
  "permissions.explain.hostPolicy": "سياسة للمضيف لا تأتي من AccessIR",
  "permissions.explain.cedarPolicyId": "معرّف سياسة Cedar",
  "permissions.explain.evaluationError": "أي خطأ في التقييم يفرض الرفض.",
  "permissions.explain.definitionEpoch": "التعريفات v{{version}} · الإيصال <receiptValue>{{receipt}}</receiptValue>",
  "permissions.explain.permissionSnapshot": "لقطة الصلاحيات <epochValue>{{epoch}}</epochValue>",
  "permissions.explain.snapshotUnavailable": "لقطة الصلاحيات غير متاحة",
  "permissions.rules.installedRules": "قواعد الوصول المثبّتة",
  "permissions.rules.noneInstalled": "لا توجد قواعد وصول مثبّتة",
  "permissions.rules.installHelp":
    "دون قواعد AccessIR، لا يسمح Cedar بشيء خارج سياسات المضيف. ثبّت تعريف سياسة لمنح الوصول.",
  "permissions.rules.filterPlaceholder": "تصفية حسب القاعدة أو الإجراء أو النوع",
  "permissions.rules.filter": "تصفية قواعد الوصول",
  "permissions.rules.count_zero": "{{shown}} من أصل {{count}} قاعدة",
  "permissions.rules.count_one": "{{shown}} من أصل قاعدة واحدة",
  "permissions.rules.count_two": "{{shown}} من أصل قاعدتين",
  "permissions.rules.count_few": "{{shown}} من أصل {{count}} قواعد",
  "permissions.rules.count_many": "{{shown}} من أصل {{count}} قاعدة",
  "permissions.rules.count_other": "{{shown}} من أصل {{count}} قاعدة",
  "permissions.rules.compiledCedarHelp":
    "تظهر شيفرة Cedar المترجمة بجانب كل قاعدة عندما توفرها الخلية. يترجم نورن كل قاعدة عند قبول التعريفات؛ ولا تترجمها لوحة التحكم بنفسها، ولا يُعدّل Cedar هنا أبدًا.",
  "permissions.rules.policy": "السياسة {{id}}",
  "permissions.rules.when": "عندما <conditionValue>{{condition}}</conditionValue>",
  "permissions.rules.on": "على",
  "permissions.rules.compiledCedar": "Cedar المترجم · للقراءة فقط",
  "permissions.rules.notServed": "لا توفره الخلية بعد.",
  "permissions.people.connectionActsAs": "يتصرف هذا الاتصال بصفة",
  "permissions.people.yourAccess": "صلاحياتك",
  "permissions.people.notPerson": "ليست جهة من نوع شخص، لذا لا توجد عضويات أو تفويضات لعرضها.",
  "permissions.people.connectionPrincipal": "الجهة التي يتصرف هذا الاتصال بصفتها",
  "permissions.people.openPerson": "فتح شخص",
  "permissions.people.open": "فتح",
  "permissions.people.readablePeople": "أشخاص يمكنك قراءتهم",
  "permissions.people.people": "الأشخاص",
  "permissions.people.noneVisible": "لا يظهر لك أي أشخاص هنا.",
  "permissions.people.typeNotInstalled":
    "لا تتضمن التعريفات المثبّتة {{objectType}}، لذا لا يتوفر دليل الأشخاص. لا يزال بإمكانك فتح شخص بمفتاحه أو عرض صلاحياتك.",
  "permissions.people.morePeople": "يوجد أشخاص آخرون؛ افتح أحدهم بمفتاحه.",
  "permissions.people.explainPerson": "شرح صلاحية لهذا الشخص",
  "permissions.membership.memberships": "العضويات",
  "permissions.membership.namespaceHelp":
    "<desiredValue>desired</desiredValue> هو ما أعلنه مسؤول. أما <observedValue>observed</observedValue> فيأتي من نظام مصدر وهو للقراءة فقط هنا.",
  "permissions.membership.personMemberships": "عضويات {{personId}}",
  "permissions.membership.noneVisible":
    "لا تظهر لك أي عضويات. تعرض الخلية العضويات التي يجوز لك قراءتها فقط، لذا لا يعني ذلك أن الشخص لا يحمل أي أدوار.",
  "permissions.delegation.delegations": "التفويضات",
  "permissions.delegation.granted": "التفويضات الممنوحة",
  "permissions.delegation.help":
    "يسمح كل تفويض لوكيل بقراءة واحدة وإجراء واحد بصلاحيات هذا الشخص الحالية، حتى انتهاء صلاحيته أو إلغائه.",
  "permissions.delegation.personDelegations": "تفويضات {{personId}}",
  "permissions.delegation.noneGranted": "لم تُمنح أي تفويضات.",
  "permissions.membership.grants": "يمنح",
  "permissions.membership.valid": "الصلاحية",
  "permissions.membership.authority": "السلطة",
  "permissions.membership.inEffectColumn": "سارية",
  "permissions.membership.outsideWindow": "خارج فترة الصلاحية الآن",
  "permissions.membership.inEffect": "سارية",
  "permissions.membership.notInEffect": "غير سارية",
  "permissions.delegation.authoritySentence":
    "يجوز لـ <executorValue>{{executor}}</executorValue> قراءة <readValue>{{read}}</readValue> وتنفيذ <actionValue>{{action}}</actionValue> على <targetValue>{{target}}</targetValue>",
  "permissions.delegation.approvedRevoked":
    "وافق عليه <approverValue>{{approvedBy}}</approverValue> · أُلغِي {{revokedAt}} بواسطة {{revokedBy}}",
  "permissions.delegation.approvedExpired":
    "وافق عليه <approverValue>{{approvedBy}}</approverValue> · انتهت صلاحيته {{expiresAt}}",
  "permissions.delegation.approvedExpires":
    "وافق عليه <approverValue>{{approvedBy}}</approverValue> · تنتهي صلاحيته {{expiresAt}}",
  "permissions.delegation.revoke": "إلغاء التفويض…",
  "permissions.delegation.confirmRevoking": "تأكيد إلغاء {{id}}",
  "permissions.delegation.revokeQuestion": "هل تريد إلغاء هذا التفويض؟",
  "permissions.delegation.revokeConsequence":
    "يفقد <executorValue>{{executor}}</executorValue> هذه السلطة فورًا. لا يمكن استعادة تفويض ملغى؛ وستلزم موافقة جديدة. اكتب <idValue>{{id}}</idValue> للتأكيد.",
  "permissions.delegation.confirmId": "معرّف التفويض للتأكيد",
  "permissions.delegation.revokeDelegation": "إلغاء التفويض",
  "permissions.delegation.notFound":
    " تجيب الخلية بالإجابة نفسها عن تفويض لم يعد موجودًا وعن تفويض لا يجوز لك تغييره. أُعيدت قراءة القائمة.",
  "permissions.delegation.revocationUncertain":
    "قد لا يكون إلغاء التفويض قد وصل إلى الخلية ({{error}}). أُعيدت قراءة القائمة؛ تحقق من حالته قبل إعادة المحاولة.",
  "permissions.delegation.revokedAt": "أُلغِي في {{date}}.",

  "graph.nodeDescription": "اضغط Enter أو مفتاح المسافة لتحديد عقدة. اضغط Delete لإزالتها وEscape للإلغاء.",
  "graph.nodeKeyboardDescription":
    "اضغط Enter أو مفتاح المسافة لتحديد عقدة، ثم استخدم مفاتيح الأسهم لتحريكها. اضغط Delete لإزالتها وEscape للإلغاء.",
  "graph.nodeMoved": "حُرّكت العقدة المحددة {{direction}}. الموضع الجديد، x: {{x}}، y: {{y}}",
  "graph.edgeDescription": "اضغط Enter أو مفتاح المسافة لتحديد رابط، ثم Delete لإزالته أو Escape للإلغاء.",
  "graph.controls": "لوحة التحكم",
  "graph.zoomIn": "تكبير",
  "graph.zoomOut": "تصغير",
  "graph.fitView": "ملاءمة العرض",
  "graph.toggleInteractivity": "تبديل التفاعل",
  "graph.miniMap": "خريطة مصغرة",
  "graph.handle": "نقطة الربط",
  "graph.moveLeft": "إلى اليسار",
  "graph.moveRight": "إلى اليمين",
  "graph.moveUp": "إلى الأعلى",
  "graph.moveDown": "إلى الأسفل",

  "apps.description":
    "صفحات تعلنها الواجهات المقبولة، وتُعرض من WidgetIR الخاص بها. تمر القراءات والإجراءات عبر الخلية؛ ويقيّم نورن الشروط.",
  "apps.noneInstalled": "لا توجد تطبيقات مثبّتة",
  "apps.installHelp":
    "التطبيق تعريف واجهة له عقد تجربة مستخدم (صفحات وربط وحقول ونماذج). ثبّت تطبيقًا مع التعريفات ليظهر هنا.",
  "apps.pages_zero": "لا توجد صفحات",
  "apps.pages_one": "صفحة واحدة",
  "apps.pages_two": "صفحتان",
  "apps.pages_few": "{{count}} صفحات",
  "apps.pages_many": "{{count}} صفحة",
  "apps.pages_other": "{{count}} صفحة",
  "apps.thisApp": "هذا التطبيق",
  "apps.noSuchPage": "لا توجد هذه الصفحة في هذا التطبيق",
  "apps.noSuchApp": "لا يوجد تطبيق مثبّت بهذا المعرّف",
  "apps.notDeclared": "لم تعلن أي واجهة مقبولة <widgetValue>{{id}}</widgetValue> في المجموعة v{{version}}.",
  "apps.invalidParameters": "لا يمكن فتح هذه الصفحة بهذه المعلمات: {{problems}}. افتحها عبر رابط تنقل في هذا التطبيق.",
  "decision.tableFallback": "جدول",
  "decision.registryReadOnly": "هذا القرار جزء من قاعدة السجل، وهي للقراءة فقط.",
  "decision.onlyRuleIr2": "يمكن تعديل مخططات القرار من نوع RuleIR 2.0 فقط هنا.",
  "decision.noDecisionTable": "لا يحتوي مخطط القرار هذا على جدول قرارات.",
  "decision.onlyTextCells": "تحتوي إحدى الخلايا على قيمة غير نصية؛ ويعدّل هذا المحرر خلايا ZEN النصية فقط.",
  "decision.reshapedError":
    "تغيّرت صفوف أو أعمدة {{names}}. يحفظ هذا المحرر نص الخلايا فقط؛ أعد بنية الجدول إلى أصلها، ثم حاول مجددًا.",
  "decision.installFailedInTransit": "فشل طلب التثبيت إلى {{baseUrl}} أثناء النقل",
  "decision.setMoved": "انتقلت المجموعة المثبّتة إلى v{{version}}",
  "decision.artifactMissing": "لم يعد {{artifactId}} في طبقة المستأجر",
  "decision.notInstalledDecision": "ليس قرارًا مثبّتًا",
  "decision.notARule": "ليس <artifactValue>{{artifactId}}</artifactValue> قاعدة في المجموعة v{{version}}.",
  "decision.checkDidNotRun": "لم يُجرَ الفحص",
  "decision.nothingToInstall": "لا شيء لتثبيته: لا تختلف أي خلية عن القرار المثبّت.",
  "decision.installUnknown":
    "فشل طلب التثبيت إلى {{baseUrl}} وتعذّرت إعادة قراءة المجموعة المثبّتة، لذا قد يكون الطلب نُفّذ أو لم يُنفّذ. أعد تحميل التعريفات وقارن قبل المحاولة مجددًا.",
  "decision.notInstalled": "لم يُثبّت",
  "decision.installNotApplied":
    "تُظهر إعادة القراءة أن المجموعة v{{version}} لا تزال نشطة. فشل الطلب قبل أن تُثبته الخلية، وغالبًا بسبب رفض فحص CORS في المتصفح. لا تقبل الخلايا ترويسة x-norn-admin-token إلا من أصول مضبوطة بدقة (#3196)، لذا أضف {{origin}} إلى الأصول المسموحة لهذه الخلية، أو افتح لوحة التحكم من أصل مسموح.",
  "decision.notSent": "لم يُرسل",
  "decision.narrowing": "تضييق النطاق: {{details}}",
  "decision.table": "جدول القرارات",
  "decision.noChanges": "لا توجد تغييرات",
  "decision.changedCells_zero": "لم تتغير أي خلايا",
  "decision.changedCells_one": "تغيّرت خلية واحدة",
  "decision.changedCells_two": "تغيّرت خليتان",
  "decision.changedCells_few": "تغيّرت {{count}} خلايا",
  "decision.changedCells_many": "تغيّرت {{count}} خلية",
  "decision.changedCells_other": "تغيّرت {{count}} خلية",
  "decision.check": "فحص",
  "decision.installOpen": "تثبيت…",
  "decision.installedSuccess":
    "ثُبّتت كمجموعة v{{version}}. أعادت الخلية فحصها وثبّتتها؛ ويعرض المحرر الآن القرار المثبّت.",
  "decision.staleNow":
    "المجموعة المثبّتة الآن هي v{{version}} (خططت وفق v{{plannedVersion}})؛ وقد تتضمن هذا التثبيت أو تثبيت شخص آخر. ما زالت تعديلاتك هنا؛ أعد التحميل لترى ما هو مثبّت الآن.",
  "decision.staleRefused":
    "رفضت الخلية التثبيت: تغيّرت المجموعة بعد v{{plannedVersion}}. ما زالت تعديلاتك هنا؛ أعد التحميل لترى ما هو مثبّت الآن.",
  "decision.discardReload": "تجاهل التعديلات وأعد التحميل",
  "decision.reshapedNotice":
    "يحفظ هذا المحرر نص الخلايا فقط. تغيّرت صفوف أو أعمدة {{names}}، لذا يتوقف الفحص والتثبيت حتى تُستعاد البنية.",
  "decision.resetStructure": "إعادة بنية الجدول إلى أصلها",
  "decision.readOnlyReason": "{{reason}} يُعرض للقراءة فقط.",
  "decision.editor": "محرر جدول القرارات",
  "decision.tables": "جداول القرارات",
  "decision.editHelp":
    "عدّل خلية لتغيير تعبير ZEN فيها؛ ويمكن تعديل أوصاف الصفوف أيضًا. الصفوف والأعمدة وسياسة المطابقة ثابتة هنا، لذا غيّرها في تعريف مصدر القرار. تعني <dashValue>-</dashValue> تحت اسم عمود أن العمود بلا حقل إدخال: كل خلية تعبير كامل على مدخلات القرار (<sliceValue>slice</sliceValue>، <eventValue>event</eventValue>).",
  "decision.candidateChecks": "النسخة المرشحة والفحوص",
  "decision.installNewSet": "تثبيت كمجموعة تعريفات جديدة",
  "decision.installDescription_zero":
    "يُرسل طبقة المستأجر كاملة دون تغيير خلايا، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installDescription_one":
    "يُرسل طبقة المستأجر كاملة مع خلية واحدة تغيّرت، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installDescription_two":
    "يُرسل طبقة المستأجر كاملة مع خليتين تغيّرتا، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installDescription_few":
    "يُرسل طبقة المستأجر كاملة مع {{count}} خلايا تغيّرت، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installDescription_many":
    "يُرسل طبقة المستأجر كاملة مع {{count}} خلية تغيّرت، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installDescription_other":
    "يُرسل طبقة المستأجر كاملة مع {{count}} خلية تغيّرت، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.adminCredential": "بيانات اعتماد تثبيت المسؤول",
  "decision.credentialHelp": "تُحفظ في الذاكرة لهذا الحفظ فقط. تحتاج هويتك أيضًا إلى norn.defs.install.",
  "decision.install": "تثبيت",
  "decision.checks": "الفحوص",
  "decision.tablePreviewHelp": "عقدة الجدول كما ستُرسل. تبقى حقول التخطيط دون تغيير.",
  "decision.checkHelp": "عدّل خلية، ثم افحصها بمدقق Rust نفسه الذي تستخدمه الخلية.",
  "decision.changedCheckHelp":
    "يشغّل الفحص مدقق Rust في هذا المتصفح مقابل قاعدة السجل المثبّتة. يعيد التثبيت الفحص في الخلية.",
  "decision.admissible": "مقبول",
  "decision.notAdmissible": "غير مقبول",
  "decision.outcomeUnknown": "النتيجة غير معروفة — أعد الفحص قبل المحاولة مجددًا",
  "decision.reloadDefinitions": "إعادة تحميل التعريفات",

  "decision.invalidVersion": "إصدار مجموعة التعريفات ليس عددًا",
  "decision.invalidDefinitionResponse": "لم يُعد GET /v1/defs كائنًا",
  "common.couldNotReach": "تعذّر الوصول إلى {{url}}",
  "live.definitionsLive": "تحديث مباشر للتعريفات · الإصدار {{revision}}",
  "live.connecting": "جارٍ الاتصال بتغييرات التعريفات…",
  "live.notLive": "التحديث المباشر للتعريفات متوقف",
  "live.noRead": "لم يعد بإمكانك قراءة التعريفات هنا.",
  "live.closed": "أغلقت الخلية تدفّق التعريفات.",

  "decision.nothingToSave": "لا يوجد ما يُحفظ: لم تتغير أي خلية أو موضع عقدة عن القرار المثبّت.",
  "decision.movedNodes_zero": "لم تُنقل أي عقدة",
  "decision.movedNodes_one": "نُقلت عقدة واحدة",
  "decision.movedNodes_two": "نُقلت عقدتان",
  "decision.movedNodes_few": "نُقلت {{count}} عقد",
  "decision.movedNodes_many": "نُقلت {{count}} عقدة",
  "decision.movedNodes_other": "نُقلت {{count}} عقدة",
  "decision.saveLayoutOpen": "حفظ التخطيط…",
  "decision.installedPendingLive": "ثُبّتت المجموعة v{{version}}. بانتظار إشعار الخلية بالتغيير لعرضها.",
  "decision.installedPendingOffline":
    "ثُبّتت المجموعة v{{version}}. التحديثات المباشرة متوقفة هنا ({{reason}})، لذا أعد التحميل لعرضها.",
  "decision.liveConnecting": "جارٍ الاتصال",
  "decision.reload": "إعادة التحميل",
  "decision.refreshFailed": "تعذرت إعادة قراءة التعريفات. ما زال المحرر يعرض v{{version}}؛ وتعديلاتك محفوظة.",
  "decision.refreshFailedWithReason":
    "تعذرت إعادة قراءة التعريفات ({{reason}}). ما زال المحرر يعرض v{{version}}؛ وتعديلاتك محفوظة.",
  "decision.upstreamChanged":
    "تغيّر هذا القرار في المصدر في v{{version}}. تعديلاتك محفوظة وما زالت تستند إلى v{{basisVersion}}؛ وسيُرفض تثبيتها الآن.",
  "decision.upstreamRemoved":
    "أُزيل هذا القرار من المصدر في v{{version}}. تعديلاتك محفوظة وما زالت تستند إلى v{{basisVersion}}؛ وسيُرفض تثبيتها الآن.",
  "decision.hideComparison": "إخفاء المقارنة",
  "decision.compare": "مقارنة",
  "decision.discardAndLoad": "تجاهل تعديلاتي وتحميل v{{version}}",
  "decision.upstreamRebased":
    "انتقلت المجموعة إلى v{{version}}؛ تغيّرت تعريفات أخرى دون هذا القرار. ستُثبّت تعديلاتك فوق v{{version}}.",
  "decision.view": "عرض المحرر",
  "decision.tableView": "الجداول",
  "decision.canvasView": "مساحة الرسم",
  "decision.tableViewHelp": "يُعدّل نص الخلايا هنا.",
  "decision.canvasViewHelp": "اسحب العقد لترتيب الرسم. تُحفظ المواضع في التخطيط، ولا تصبح جزءًا من القرار.",
  "decision.saveLayout": "حفظ تخطيط مساحة الرسم",
  "decision.layoutDescription_zero":
    "يحفظ التخطيط دون تغيير مواضع العقد، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.layoutDescription_one":
    "يحفظ موضع عقدة واحدة في ملف التخطيط المرافق، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.layoutDescription_two":
    "يحفظ موضعي عقدتين في ملف التخطيط المرافق، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.layoutDescription_few":
    "يحفظ مواضع {{count}} عقد في ملف التخطيط المرافق، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.layoutDescription_many":
    "يحفظ مواضع {{count}} عقدة في ملف التخطيط المرافق، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.layoutDescription_other":
    "يحفظ مواضع {{count}} عقدة في ملف التخطيط المرافق، وفق المجموعة v{{version}}. تُرسل القرارات كما هي مثبّتة، فتبقى بصماتها وإيصال الفحص كما هي.",
  "decision.installMovedCellDescription_zero":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) دون نقل عقد، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellDescription_one":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) ونقل عقدة واحدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellDescription_two":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) ونقل عقدتين، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellDescription_few":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) ونقل {{count}} عقد، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellDescription_many":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) ونقل {{count}} عقدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellDescription_other":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلية واحدة ({{cells}}) ونقل {{count}} عقدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_zero":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} دون نقل عقد، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_one":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} ونقل عقدة واحدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_two":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} ونقل عقدتين، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_few":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} ونقل {{count}} عقد، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_many":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} ونقل {{count}} عقدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.installMovedCellsDescription_other":
    "يُرسل طبقة المستأجر كاملة مع تعديل خلايا عددها {{cells}} ونقل {{count}} عقدة، وفق المجموعة v{{version}}. تعيد الخلية فحصها؛ ولا تُرسل قاعدة السجل وتبقى كما اختيرت.",
  "decision.tableRemoved": "أُزيل الجدول",
  "decision.tableStructureChanged": "تغيّرت الصفوف أو الأعمدة",
  "decision.upstreamComparison": "مقارنة مع المصدر",
  "decision.changedUpstream": "تغيّر في المصدر في v{{version}}",
  "decision.noChangedTableCell":
    "لم تتغير أي خلية جدول؛ تغيّر القرار في موضع آخر (عقدة أخرى أو بيانات وصفية أو تخطيطه).",
  "decision.cellAlsoEdited": "عدّلت هذه الخلية أيضًا",
  "decision.canvasUndone":
    "تتغير مواضع العقد فقط هنا؛ وقد أُلغي ذلك التعديل. التوصيلات والعقد جزء من تعريف مصدر القرار.",
  "common.dismiss": "إغلاق",
  "common.yes": "نعم",
  "common.no": "لا",
  "ws.mode.label": "الوضع",
  "ws.mode.workspace": "الأعمال",
  "ws.mode.builder": "البيانات",
  "ws.nav.home": "الرئيسية",
  "ws.nav.areas": "خريطة المجالات",
  "ws.nav.businessAreas": "مجالات العمل",
  "ws.how.label": "كيف يعمل هذا",
  "ws.how.home": "المؤشرات استعلامات DuckDB على لقطة مصرّح بها من الخلية؛ افتح مصدر أي بطاقة لترى الموضع الذي حُسبت عنده.",
  "ws.how.areas": "أنواع الأنطولوجيا مربوطة بأنواع Core المشتركة. المجالات تأتي من التطبيقات المثبّتة، والخطوط روابط مُعرّفة بين أنواعها.",
  "ws.how.list": "مُولّدة من تعريف النوع: الأعمدة والتسميات وتنسيق المبالغ والحالات تأتي من الأنطولوجيا، لا من شاشة مبنية يدويًا.",
  "ws.how.record": "روابط مُنمّطة؛ كل خطوة تخضع لفحص الصلاحيات. تُقرأ السجلات المرتبطة خطوة مصرّحًا بها في كل مرة.",
  "ws.how.why": "المصدر: المستند ← الملاحظة ← التحويل ← القيمة. كل قيمة تستشهد بالإجراء أو سجل المصدر الذي كتبها.",
  "ws.how.restricted": "سياسة Cedar على مستوى الحقل؛ الاستخدام ≠ الكشف. القيم المخفية تُحتسب وتُربط، لكنها لا تُعرض لك.",
  "ws.how.builder": "كل تغيير إجراء مصرّح به مع إيصال. التعريفات والسجل والصلاحيات هي طبقة التحكم خلف مساحة العمل.",
  "ws.hiddenByPolicy": "مخفي بموجب السياسة",
  "ws.hiddenByPolicyHelp": "حجبت الخلية هذه القيمة عن دورك.",
  "ws.hiddenByPolicyMarkings": "محجوب عن دورك · {{markings}}",
  "ws.titleHidden": "الاسم مخفي بموجب السياسة",
  "ws.home.title": "اليوم",
  "ws.home.signedInAs": "مسجّل الدخول باسم {{actor}}",
  "ws.home.searchHint": "ابحث عن أي شيء",
  "ws.home.metrics": "المؤشرات",
  "ws.home.attention": "أعمال مفتوحة",
  "ws.home.nothingOpen": "لا توجد سجلات بانتظار خطوة تالية.",
  "ws.home.openCount_zero": "لا شيء مفتوح{{more}}",
  "ws.home.openCount_one": "{{count}}{{more}} مفتوح",
  "ws.home.openCount_two": "{{count}}{{more}} مفتوحان",
  "ws.home.openCount_few": "{{count}}{{more}} مفتوحة",
  "ws.home.openCount_many": "{{count}}{{more}} مفتوحًا",
  "ws.home.openCount_other": "{{count}}{{more}} مفتوح",
  "ws.home.openMap": "افتح الخريطة",
  "ws.home.recent": "شوهدت مؤخرًا",
  "ws.home.recentEmpty": "تظهر هنا السجلات التي تفتحها.",
  "ws.home.howConnected": "كيف يترابط العمل",
  "ws.home.asOfHead": "حتى الموضع {{head}}",
  "ws.home.lineage": "المصدر",
  "ws.home.metricPending": "لم يُحسب بعد.",
  "ws.home.metricUnavailable": "هذا المؤشر غير مقروء هنا.",
  "ws.areas.title": "خريطة المجالات",
  "ws.areas.description": "كل مجال تطبيق مثبّت أو نطاق Core مشترك. الخطوط روابط مُنمّطة بين سجلاتها.",
  "ws.areas.mapLabel": "مجالات العمل والروابط بينها",
  "ws.areas.none": "لا توجد مجالات عمل مثبّتة.",
  "ws.areas.noSuchArea": "هذا المجال ليس ضمن التعريفات المثبّتة.",
  "ws.areas.core": "Core",
  "ws.areas.coreHelp": "نطاق Core مشترك",
  "ws.areas.types_zero": "لا أنواع",
  "ws.areas.types_one": "نوع واحد",
  "ws.areas.types_two": "نوعان",
  "ws.areas.types_few": "{{count}} أنواع",
  "ws.areas.types_many": "{{count}} نوعًا",
  "ws.areas.types_other": "{{count}} نوع",
  "ws.areas.lifecycleStates_zero": "لا حالات",
  "ws.areas.lifecycleStates_one": "حالة واحدة",
  "ws.areas.lifecycleStates_two": "حالتان",
  "ws.areas.lifecycleStates_few": "{{count}} حالات",
  "ws.areas.lifecycleStates_many": "{{count}} حالة",
  "ws.areas.lifecycleStates_other": "{{count}} حالة",
  "ws.areas.flowLabel": "كيف تتدفق السجلات في {{area}}",
  "ws.areas.connections": "روابط مع مجالات أخرى",
  "ws.areas.allTypes": "كل الأنواع",
  "ws.list.record": "السجل",
  "ws.list.total_zero": "لا سجلات",
  "ws.list.total_one": "سجل واحد",
  "ws.list.total_two": "سجلان",
  "ws.list.total_few": "{{count}} سجلات",
  "ws.list.total_many": "{{count}} سجلًا",
  "ws.list.total_other": "{{count}} سجل",
  "ws.list.loadedMore_zero": "لم يُحمّل شيء · المزيد متاح",
  "ws.list.loadedMore_one": "حُمّل سجل واحد · المزيد متاح",
  "ws.list.loadedMore_two": "حُمّل سجلان · المزيد متاح",
  "ws.list.loadedMore_few": "حُمّلت {{count}} سجلات · المزيد متاح",
  "ws.list.loadedMore_many": "حُمّل {{count}} سجلًا · المزيد متاح",
  "ws.list.loadedMore_other": "حُمّل {{count}} سجل · المزيد متاح",
  "ws.list.importedFrom": "مستورد من {{source}}",
  "ws.list.filter": "تصفية",
  "ws.list.filterPlaceholder": "صفِّ {{name}}…",
  "ws.list.byStatus": "التصفية حسب الحالة",
  "ws.list.empty": "لا توجد {{name}} مرئية لك",
  "ws.list.emptyHelp": "لم تُرجع الخلية أي سجلات مسموح لك بقراءتها في هذا النطاق.",
  "ws.list.noMatch": "لا شيء مما حُمّل يطابق هذه التصفية.",
  "ws.list.loadMore": "تحميل المزيد",
  "ws.list.inspect": "افحص في المُنشئ",
  "ws.record.inspect": "افحص في المُنشئ",
  "ws.record.notVisible": "هذا السجل غير مرئي لك",
  "ws.record.notVisibleHelp": "لا تعرض الخلية هذا الـ{{type}} لدورك، أو أنه غير موجود.",
  "ws.record.lifecycle": "دورة الحياة",
  "ws.cmd.title": "الإجراءات",
  "ws.cmd.checkedAtCommit": "لا يمكن التحقق من صلاحية سجل جديد إلا عند اعتماده؛ تتحقق الخلية من السياسة حينها وتعرض أي رفض.",
  "ws.cmd.checking": "جارٍ التحقق من الصلاحية لدى الخلية…",
  "ws.cmd.denied": "غير مسموح لك: {{reason}}",
  "ws.cmd.unavailable": "رُفض التحقق من الصلاحية: {{reason}}",
  "ws.cmd.readOnly": "يستطيع {{actor}} قراءة هذا السجل لكنه لا يستطيع تنفيذ إجراءات عليه. {{reason}}",
  "ws.cmd.confirm": "يُنفَّذ باسم {{actor}}. تتحقق الخلية من السياسة مجددًا، ثم تعتمد التغيير وتسجّله في السجل.",
  "ws.cmd.commit": "اعتماد",
  "ws.cmd.committing": "جارٍ الاعتماد…",
  "ws.cmd.committed": "اعتُمد ‎#{{seq}}",
  "ws.cmd.replayed": "اعتُمد سابقًا؛ هذا هو الإيصال الأصلي.",
  "ws.cmd.refused": "رفضت الخلية هذا الإجراء",
  "ws.cmd.receipt": "عرض الإيصال",
  "ws.cmd.chooseRecord": "اختر سجلًا موجودًا…",
  "ws.cmd.whyDenied": "لماذا لا أستطيع تنفيذ «{{action}}»؟",
  "ws.cmd.deniedHelp": "تحققت الخلية من صلاحياتك الحالية ولم تسمح بهذا الإجراء على هذا السجل. لم يتغير السجل.",
  "ws.cmd.deniedScope": "مؤسسة الطلب أو بيئته غير محددة أو خارج نطاق صلاحياتك الحالية. تحقق من النطاق المحدد. لم يتغير السجل.",
  "ws.cmd.deniedCapability": "صلاحياتك الحالية لا تشمل هذا الإجراء في هذه المؤسسة والبيئة. اطلب من المسؤول مراجعة صلاحياتك. لم يتغير السجل.",
  "ws.cmd.deniedDelegation": "لم تقبل الخلية التفويض لهذا الإجراء. تحقق من نطاقه والموافقة عليه وتاريخ انتهائه. لم يتغير السجل.",
  "ws.cmd.deniedManagement": "لا تسمح قيود إدارة الهوية في الخلية بهذا الإجراء. اطلب من المسؤول مراجعة القيد. لم يتغير السجل.",
  "ws.cmd.deniedInvalidRequest": "تعذر تقييم طلب الصلاحية لأن الإجراء أو الهوية أو المدخلات غير صالحة. تحقق من تفاصيل الطلب. لم يتغير السجل.",
  "ws.cmd.deniedEvaluation": "تعذر على الخلية تقييم طلب الصلاحية بأمان. اطلب من المسؤول مراجعة فحص الصلاحية. لم يتغير السجل.",
  "ws.cmd.deniedStaleAccess": "تغيرت صلاحياتك أثناء فحص هذا الإجراء. حدث الصفحة وحاول مجدداً. لم يتغير السجل.",
  "ws.cmd.deniedTargetUnavailable": "السجل المستهدف غير متاح لهذا الإجراء. حدث السجل قبل المحاولة مجدداً. لم يتغير السجل.",
  "ws.cmd.required": "مطلوب",
  "ws.cmd.fixed": "من هذا السجل",
  "ws.cmd.invalidNumber": "أدخل رقمًا.",
  "ws.cmd.invalidJson": "أدخل JSON صالحًا.",
  "ws.record.moveTo": "انقل إلى {{state}}",
  "ws.record.moreActions": "المزيد",
  "ws.record.availableFrom": "من {{states}}",
  "ws.record.noApp": "لا يوجد تطبيق مثبّت ينفّذ هذه الخطوة.",
  "ws.record.openInApp": "افتح في التطبيق",
  "ws.record.details": "التفاصيل",
  "ws.record.identifiers_zero": "المعرّفات وحقول النظام",
  "ws.record.identifiers_one": "المعرّفات وحقول النظام · {{count}}",
  "ws.record.identifiers_two": "المعرّفات وحقول النظام · {{count}}",
  "ws.record.identifiers_few": "المعرّفات وحقول النظام · {{count}}",
  "ws.record.identifiers_many": "المعرّفات وحقول النظام · {{count}}",
  "ws.record.identifiers_other": "المعرّفات وحقول النظام · {{count}}",
  "ws.related.title": "مرتبط",
  "ws.related.none": "لا توجد سجلات مرتبطة.",
  "ws.related.hidden": "روابط هذا السجل مخفية عن دورك.",
  "ws.related.failed": "تعذّرت قراءة الروابط.",
  "ws.related.pointingHere": "هذه السجلات ترتبط بهذا السجل.",
  "ws.related.showAll_zero": "لا شيء",
  "ws.related.showAll_one": "اعرض سجلًا واحدًا",
  "ws.related.showAll_two": "اعرض السجلين",
  "ws.related.showAll_few": "اعرض الـ{{count}} كلها",
  "ws.related.showAll_many": "اعرض الـ{{count}} كلها",
  "ws.related.showAll_other": "اعرض الـ{{count}} كلها",
  "ws.related.showFewer": "اعرض أقل",
  "ws.related.unreadable": "غير مقروء لدورك",
  "ws.why.title": "لماذا يبدو هكذا",
  "ws.why.fullLineage": "المصدر الكامل",
  "ws.why.hidden": "سجل هذا السجل مخفي عن دورك.",
  "ws.why.createdBy": "أُنشئ بواسطة «{{action}}» · {{actor}} · {{when}}",
  "ws.why.truncated": "السجل الأقدم غير معروض",
  "ws.why.noSource": "لا مصدر مسجّل",
  "ws.why.sourceDocument": "المستند المصدر",
  "ws.why.observed": "رُصد",
  "ws.why.mapping": "التحويل",
  "ws.why.actionInput": "مدخل الإجراء",
  "ws.why.byActor": "بواسطة {{actor}}",
  "ws.why.committed": "اعتُمد",
  "ws.why.thisField": "هذا الحقل",
  "ws.why.chainFor": "من أين جاء {{field}}",
  "ws.search.open": "بحث",
  "ws.search.title": "ابحث في مساحة العمل",
  "ws.search.placeholder": "ابحث عن مجال أو مجموعة أو سجل أو مفتاح…",
  "ws.search.go": "انتقل إلى",
  "ws.search.collections": "المجموعات",
  "ws.search.records": "السجلات",
  "ws.search.openKey": "افتح «{{key}}»",
  "ws.search.nothing": "لا نتائج. جرّب اسم مجموعة أو مفتاحًا مطابقًا.",
  "ws.why.unavailable": "تعذّرت قراءة سجل هذا السجل.",
  "ws.why.evidenceUnavailable": "تعذّرت قراءة أدلة المصدر المسجّلة.",
  "ws.home.listUnavailable": "{{name}} غير مقروءة هنا.",
  "overview.displayGaps": "ثغرات بيانات العرض",
  "overview.displayGapsHelp_zero": "لا توجد مواضع اشتُقّت فيها التسميات من المعرّفات.",
  "overview.displayGapsHelp_one": "موضع واحد اشتُقّت فيه التسمية من معرّف. يزيله التصريح باسم عرض أو خاصية عنوان.",
  "overview.displayGapsHelp_two": "موضعان اشتُقّت فيهما التسميات من معرّفات. يزيلهما التصريح بأسماء العرض وخصائص العنوان.",
  "overview.displayGapsHelp_few": "{{count}} مواضع اشتُقّت فيها التسميات من معرّفات. يزيلها التصريح بأسماء العرض وخصائص العنوان.",
  "overview.displayGapsHelp_many": "{{count}} موضعًا اشتُقّت فيه التسميات من معرّفات. يزيلها التصريح بأسماء العرض وخصائص العنوان.",
  "overview.displayGapsHelp_other": "{{count}} موضع اشتُقّت فيه التسميات من معرّفات. يزيلها التصريح بأسماء العرض وخصائص العنوان.",
  "ws.why.allFields_zero": "لا حقول",
  "ws.why.allFields_one": "اعرض حقلًا واحدًا",
  "ws.why.allFields_two": "اعرض الحقلين",
  "ws.why.allFields_few": "اعرض الحقول الـ{{count}}",
  "ws.why.allFields_many": "اعرض الـ{{count}} حقلًا",
  "ws.why.allFields_other": "اعرض الـ{{count}} حقل",
  "ws.related.withheld": "روابط هذا السجل محجوبة لأن مفاتيحها تحمل تصنيفات لا يمكنك رؤيتها.",
  "objects.writtenByAction": "مدخل إجراء · {{action}} · بواسطة {{actor}} · {{commit}}",
  "ws.lineage.title": "المصدر",
  "ws.lineage.freshness": "الحداثة",
  "ws.lineage.freshUntil": "حديث حتى",
  "ws.lineage.sourceHead": "موضع المصدر",
  "ws.lineage.definition": "التعريف",
  "ws.lineage.result": "النتيجة الثابتة",
  "ws.lineage.openMetric": "افتح المؤشر و«لماذا»",
  "ws.lineage.openResult": "افتح لقطة النتيجة",
  "dv.nav.data": "البيانات",
  "dv.nav.summary": "الملخص",
  "dv.nav.analyze": "تحليل",
  "dv.nav.internals": "الداخلية",
  "dv.nav.ontology": "الأنطولوجيا",
  "dv.nav.explore": "استكشاف",
  "dv.nav.metrics": "المؤشرات",
  "dv.nav.sources": "المصادر",
  "dv.nav.policy": "السياسة",
  "dv.how.home": "الخلية نفسها في وضع الأعمال، مقروءة حسب المعنى: الأنطولوجيا والسجلات والمؤشرات والمصادر والسياسة. كل قراءة مصرّح بها لك.",
  "dv.how.ontology": "الأنواع والخصائص والروابط المُنمّطة من التعريفات المعتمدة، مع ربطها بـ Core وتصنيفاتها. الأعداد قراءات مصرّح بها.",
  "dv.how.explore": "ابدأ من مجموعة سجلات وتنقّل عبر الروابط المُنمّطة. الربط يستخدم خصائص المفاتيح المعلنة؛ المفاتيح المحجوبة لا تُربط أبدًا.",
  "dv.how.metrics": "المؤشرات استعلامات DuckDB على لقطة مصرّح بها. يعرض كل صف موضع المصدر والتعريف والنتيجة الثابتة.",
  "dv.how.sources": "المصدر: المستند ← الملاحظة ← التحويل ← القيمة. الإيصالات من أدلة مسجّلة، لا من تخمين.",
  "dv.how.policy": "تقرّر Cedar لكل حقل. ما تراه هنا هو ما أجابت به الخلية لك، لا تخمين حسب الدور.",
  "dv.home.title": "مساحة البيانات",
  "dv.home.description": "عرض المحلّل للعمل نفسه: الأنطولوجيا خلف الشاشات، وسجلات يمكنك التنقل بينها، ومؤشرات بمصادرها، ومن أين جاءت القيم، وما تسمح لك السياسة برؤيته.",
  "dv.home.types": "الأنواع",
  "dv.home.typesHint": "{{tenant}} للمستأجر · {{core}} من Core",
  "dv.home.properties": "الخصائص",
  "dv.home.links": "الروابط",
  "dv.home.bridges_zero": "لا روابط بين المجالات",
  "dv.home.bridges_one": "رابط واحد بين المجالات",
  "dv.home.bridges_two": "رابطان بين المجالات",
  "dv.home.bridges_few": "{{count}} روابط بين المجالات",
  "dv.home.bridges_many": "{{count}} رابطًا بين المجالات",
  "dv.home.bridges_other": "{{count}} رابط بين المجالات",
  "dv.home.sources": "أنظمة المصدر والتحويلات وإيصالات الملاحظة لكل سجل.",
  "dv.home.mappings_zero": "لا تحويلات",
  "dv.home.mappings_one": "تحويل واحد",
  "dv.home.mappings_two": "تحويلان",
  "dv.home.mappings_few": "{{count}} تحويلات",
  "dv.home.mappings_many": "{{count}} تحويلًا",
  "dv.home.mappings_other": "{{count}} تحويل",
  "dv.home.sourceSystems": "أنظمة المصدر",
  "dv.home.policies": "السياسات",
  "dv.home.version": "التعريفات",
  "dv.home.ontology": "كل نوع بخصائصه وروابطه وربطه بـ Core وتصنيفاته وعدد سجلاته.",
  "dv.home.explore": "ابحث في نوع ثم تنقّل: هؤلاء العملاء ← طلباتهم ← مدفوعاتهم.",
  "dv.home.graph": "تحقّق من جوار سجل واحد رابطًا برابط، مع مفتش جانبي.",
  "dv.home.metrics": "كل مؤشر بتعريفه وحداثته وموضع مصدره ونتيجته الثابتة والانتقال إلى الصفوف.",
  "dv.home.policy": "ما يمكن لهذا الكيان رؤيته وما لا يمكنه، حقلًا بحقل، ولماذا.",
  "dv.ontology.description": "الأنطولوجيا المعتمدة: الأنواع مجمّعة حسب مجال العمل، مع الخصائص والروابط المُنمّطة وربطها بـ Core والتصنيفات.",
  "dv.ontology.index": "الأنواع",
  "dv.ontology.filter": "صفِّ الأنواع أو الخصائص…",
  "dv.ontology.explore": "استكشف السجلات",
  "dv.ontology.businessList": "قائمة الأعمال",
  "dv.ontology.definition": "التعريف",
  "dv.ontology.records": "السجلات",
  "dv.ontology.recordsHint": "المقروءة لك",
  "dv.ontology.countRefused": "لم تُحصِ الخلية هذه السجلات لك.",
  "dv.ontology.linksOut": "روابط صادرة",
  "dv.ontology.linksIn": "روابط واردة",
  "dv.ontology.marked": "حقول مصنّفة",
  "dv.ontology.properties": "الخصائص",
  "dv.ontology.colLabel": "التسمية",
  "dv.ontology.colId": "الخاصية",
  "dv.ontology.colType": "النوع",
  "dv.ontology.colRole": "تُقرأ كـ",
  "dv.ontology.colMarkings": "التصنيفات",
  "dv.ontology.links": "الروابط المُنمّطة",
  "dv.ontology.out": "صادر",
  "dv.ontology.in": "وارد",
  "dv.ontology.declaredBy": "معلن من {{ns}}",
  "dv.ontology.noLinks": "لا روابط مُنمّطة.",
  "dv.ontology.core": "الربط بـ Core والمصادر",
  "dv.ontology.implements": "ينفّذ",
  "dv.ontology.mapsTo": "يرتبط بـ",
  "dv.ontology.bridgedFrom": "مربوط من",
  "dv.ontology.via": "عبر {{link}}",
  "dv.ontology.mapping": "تحويل",
  "dv.ontology.sourceSchema": "مخطط مصدر",
  "dv.ontology.noCore": "لا واجهة Core ولا رابط Core ولا تحويل مصدر معلن.",
  "dv.ontology.lifecycle": "دورة الحياة",
  "dv.role.title": "عنوان",
  "dv.role.identifier": "معرّف",
  "dv.role.status": "حالة",
  "dv.role.money": "مبلغ",
  "dv.role.currency": "عملة",
  "dv.role.date": "تاريخ",
  "dv.role.quantity": "كمية",
  "dv.role.reference": "مرجع",
  "dv.role.contact": "اتصال",
  "dv.role.flag": "علامة",
  "dv.role.text": "نص",
  "dv.role.technical": "نظام",
  "dv.explore.description": "ابحث في سجلات نوع واحد، ثم تنقّل عبر الروابط المُنمّطة إلى السجلات المرتبطة.",
  "dv.explore.start": "ابدأ من",
  "dv.explore.chain": "مسار التنقل",
  "dv.explore.removeStep": "أزل آخر تنقّل",
  "dv.explore.filter": "صفِّ هذه المجموعة…",
  "dv.explore.pivot": "تنقّل",
  "dv.explore.refused": "لم تُرجع الخلية هذه المجموعة لك.",
  "dv.explore.noKey": "لا يعلن هذا الرابط خاصية مفتاح، لذا لا يُتبع إلا سجلًا بسجل. افتح رسم السجل بدلًا من ذلك.",
  "dv.explore.empty": "لا سجلات مقروءة في هذه المجموعة.",
  "dv.explore.emptyPartial": "جرى البحث في السجلات المحمّلة حتى الآن فقط.",
  "dv.explore.loadMore": "تحميل مزيد من السجلات",
  "dv.explore.loading": "جارٍ التحميل…",
  "dv.explore.partialRoot": "تُعرض {{shown}} سجلات محمّلة حتى الآن؛ ويستخدمها البحث والتنقّل.",
  "dv.explore.partial": "يُعرض أول {{shown}} سجل؛ يغطي المسح 2,000 سجل كحد أقصى لكل نوع.",
  "dv.explore.note": "يربط التنقّل على خصائص المفاتيح المعلنة عبر قراءات مصرّح بها؛ المفاتيح المحجوبة لا تُربط.",
  "dv.metrics.description": "كل مؤشر مثبّت: قيمته وحداثته وموضع المصدر الذي حُسب عنده وتعريفه ونتيجته الثابتة.",
  "dv.metrics.none": "لا مؤشرات مثبّتة في هذا النطاق.",
  "dv.metrics.drill": "استكشف {{name}}",
  "dv.metrics.row": "الصف",
  "dv.metrics.value": "القيمة",
  "dv.metrics.groups_zero": "لا مجموعات",
  "dv.metrics.groups_one": "مجموعة واحدة",
  "dv.metrics.groups_two": "مجموعتان",
  "dv.metrics.groups_few": "{{count}} مجموعات",
  "dv.metrics.groups_many": "{{count}} مجموعة",
  "dv.metrics.groups_other": "{{count}} مجموعة",
  "dv.sources.description": "من أين تأتي القيم: أنظمة المصدر المتصلة، وتحويلاتها إلى الأنطولوجيا، والإيصالات خلف كل سجل.",
  "dv.sources.systems": "أنظمة المصدر",
  "dv.sources.noSystems": "لا مخطط مصدر ولا موصّل مثبّت في هذا النطاق.",
  "dv.sources.connector": "موصّل",
  "dv.sources.schemaShape": "{{datasets}} مجموعات بيانات · {{fields}} حقول",
  "dv.sources.mappings": "التحويلات",
  "dv.sources.noMappings": "لا تحويلات مثبّتة في هذا النطاق.",
  "dv.sources.lookup": "إيصالات سجل",
  "dv.sources.mappedTag": "محوّل",
  "dv.sources.keyPlaceholder": "مفتاح السجل",
  "dv.sources.show": "اعرض",
  "dv.sources.noReceipts": "لا تتوفر أدلة مصدر لهذا الإصدار. ربما كُتب بإجراء مسجّل؛ افتح «لماذا» لترى.",
  "dv.sources.openWhy": "افتح «لماذا»",
  "dv.receipt.title": "إيصالات المصدر",
  "dv.receipt.from": "من",
  "dv.receipt.via": "عبر",
  "dv.receipt.observed": "رُصد {{when}}",
  "dv.receipt.recorded": "سُجّل {{when}}",
  "dv.receipt.commit": "اعتماد #{{commit}}",
  "dv.receipt.fields": "وفّر: {{fields}}",
  "dv.policy.description": "ما يمكن لهذا الكيان رؤيته وما لا يمكنه، حسب النوع والحقل، كما أجابت الخلية.",
  "dv.policy.principalUnavailable": "لم تحدد الخلية الكيان.",
  "dv.policy.principal": "الكيان",
  "dv.policy.roles": "الأدوار",
  "dv.policy.units": "وحدات العمل",
  "dv.policy.policies": "سياسات الوصول",
  "dv.policy.explain": "القراءات مصرّح بها لكل سجل ولكل حقل. الحقول المصنّفة تبقى صالحة في الروابط والمؤشرات لكنها محجوبة عنك ما لم تكشفها سياستك (الاستخدام ≠ الكشف).",
  "dv.policy.type": "النوع",
  "dv.policy.access": "وصولك",
  "dv.policy.withheld": "محجوب عنك",
  "dv.policy.declared": "التصنيفات المعلنة",
  "dv.policy.refused": "غير مقروء",
  "dv.policy.read": "مقروء",
  "dv.policy.readMasked": "مقروء مع حجب جزئي",
  "dv.policy.none": "لا سجلات مرئية",
  "dv.policy.more": "القواعد والتفسيرات في",
  "dv.source.tab": "المصدر",
  "dv.source.imported": "مستورد من",
  "dv.source.authored": "مكتوب في",
  "dv.source.generated": "مولَّد بواسطة",
  "dv.source.recorded": "الأصل المسجّل",
  "dv.source.members": "حقول المصدر ← خصائص Norn",
  "dv.source.sourceField": "حقل المصدر",
  "dv.source.nornProperty": "خاصية Norn",
  "dv.source.compiled": "IR المُترجَم",
  "dv.sources.someMasked": "بعض الحقول محجوبة عنك، لذا قد تكون أدلتها محجوبة أيضًا.",
  "dv.policy.accessSampled": "وصولك (سجل واحد كعينة)",
  // Workbooks (#3379)
  "dv.home.workbooks": "أوراق وخلايا دفتر فوق التحويلات: طابِق نظامين، راجِع الأزواج، ثم ارفع القاعدة إلى مزامنة.",
  "wb.nav": "دفاتر العمل",
  "wb.title": "طلبات Shopify ↔ ERPNext",
  "wb.description": "هل يتفق المتجر مع الدفاتر؟ كل خلية تقرأ سجلات حيّة من هذه الخلية، والمطابقة تقرن بينها، وكل حكم تصدره يُسجَّل إجراءً مصرَّحًا به مع إيصال.",
  "wb.how": "دفتر العمل صفحة من الخلايا تُقرأ من الأعلى إلى الأسفل: مصادر، ثم تحويل، ثم مطابقة، ثم قائمة مراجعة، ثم رسم. ناتج كل خلية ورقة حيّة، وأصلها يبيّن من أين جاء كل عمود.",
  "wb.list.title": "دفاتر العمل",
  "wb.list.description": "دفاتر بأسلوب الجداول فوق التحويلات التي تُبقي أنظمتك متزامنة.",
  "wb.list.orders": "طابِق طلبات المتجر مع أوامر بيع ERPNext، وراجِع ما لا يتفق، ثم ارفع القاعدة إلى مزامنة.",
  "wb.list.cells": "مصادر · تحويل · مطابقة · مراجعة · رسم",
  "wb.list.notInstalled": "لا توجد في هذه الخلية تغذية لطلبات Shopify بعد.",
  "wb.unknown": "لا يوجد دفتر عمل بهذا الاسم.",
  "wb.notInstalled": "لا توجد تغذية لطلبات Shopify في هذه الخلية",
  "wb.notInstalledBody": "يحتاج دفتر العمل إلى النوعين shopify.Order وcommerce.SalesOrder. ثبّت تعريفات مطابقة الطلبات لاستخدامه.",
  "wb.run": "تشغيل",
  "wb.readRefused": "تعذّرت قراءة هذه الورقة",
  "wb.hidden": "محجوب بالسياسة",
  "wb.noReference": "لا مرجع مسجّل",
  "wb.kind.source": "مصدر",
  "wb.kind.transform": "تحويل",
  "wb.kind.match": "مطابقة",
  "wb.kind.review": "مراجعة",
  "wb.kind.chart": "رسم",
  "wb.cell.shopify": "طلبات Shopify",
  "wb.cell.erp": "أوامر بيع ERPNext",
  "wb.cell.normalize": "قراءة نصوص Shopify كأرقام وأيام",
  "wb.cell.match": "مطابقة الطلبات",
  "wb.cell.review": "مراجعة الأزواج",
  "wb.cell.chart": "غير المتطابق أسبوعيًا",
  "wb.cell.expand": "توسيع الخلية",
  "wb.cell.collapse": "طيّ الخلية",
  "wb.lineage.toggle": "الأصل",
  "wb.lineage.chain": "من أين تأتي صفوف هذه الخلية",
  "wb.lineage.column": "العمود",
  "wb.lineage.from": "يأتي من",
  "wb.lineage.means": "ماذا تعني القيمة",
  "wb.sheet.filter": "تصفية الصفوف",
  "wb.sheet.filtered": "{{shown}} من {{total}} صفًا",
  "wb.sheet.noMatch": "لا يطابق أي صف هذا المرشّح.",
  "wb.col.order": "الطلب",
  "wb.col.placed": "وقت الطلب",
  "wb.col.total": "الإجمالي",
  "wb.col.currency": "العملة",
  "wb.col.status": "الحالة",
  "wb.col.customer": "العميل",
  "wb.col.reference": "مرجع ERP",
  "wb.col.date": "التاريخ",
  "wb.col.amount": "المبلغ",
  "wb.col.day": "اليوم",
  "wb.col.shopifyText": "كما أرسله Shopify",
  "wb.col.verdict": "الحكم",
  "wb.col.confidence": "الثقة",
  "wb.col.delta": "فرق الإجمالي",
  "wb.col.days": "فارق الأيام",
  "wb.col.why": "السبب",
  "wb.side.shopify": "Shopify",
  "wb.side.erp": "ERPNext",
  "wb.side.noShopify": "لا يوجد طلب مقابل في المتجر.",
  "wb.side.noErp": "لا يوجد أمر مقابل في ERPNext.",
  "wb.empty.shopify": "لم تصل أي طلبات من Shopify بعد.",
  "wb.empty.erp": "لم تصل أي أوامر بيع من ERPNext بعد.",
  "wb.empty.match": "لا أزواج بهذا الحكم.",
  "wb.empty.chart": "لا شيء لرسمه بعد.",
  "wb.stat.shopify": "طلبات Shopify",
  "wb.stat.erp": "أوامر ERPNext ضمن الفترة",
  "wb.stat.review": "تحتاج مراجعة",
  "wb.stat.unmatched": "غير متفقة",
  "wb.stat.read": "قُرئت",
  "wb.stat.live": "حيّة من هذه الخلية",
  "wb.normalize.allRead": "قُرئ كل إجمالي ووقت",
  "wb.normalize.body": "يرسل Shopify المبالغ والأوقات نصوصًا (\"3600.00\"، \"2026-09-14T21:40:00+03:00\"). تقرأ هذه الخلية كل إجمالي رقمًا وكل وقت يومًا تقويميًا كما رآه العميل بتوقيت المتجر. الصف الذي يتعذّر قراءته يُعلَّم بالأحمر ولا يُطابَق بالمبلغ أبدًا.",
  "wb.match.summary": "{{pairs}} زوجًا · {{review}} للمراجعة",
  "wb.match.filter": "عرض الأزواج حسب الحكم",
  "wb.match.all": "الكل",
  "wb.rule.reference": "المرجع",
  "wb.rule.referenceBody": "يحمل طلب المتجر أمر ERPNext الذي سجّلته المزامنة. نفس الإجمالي: متطابق. إجمالي مختلف: اختلاف في المبلغ. طلب متجر ثانٍ عليه: مكرّر.",
  "wb.rule.amountDate": "العميل + المبلغ + التاريخ",
  "wb.rule.amountDateBody": "بلا مرجع: يُقرَن بأمر ERPNext غير محجوز بالإجمالي نفسه خلال ±{{days}} يوم، مع تفضيل العميل نفسه. يؤكد شخصٌ كل زوج من هذا النوع.",
  "wb.rule.days": "الأيام",
  "wb.rule.amount": "المبلغ",
  "wb.rule.leftover": "المتبقّي",
  "wb.rule.leftoverBody": "طلب المتجر بلا زوج مفقود في ERPNext؛ وأمر ERPNext ضمن تواريخ المتجر بلا زوج مفقود في Shopify.",
  "wb.rules.exact": "مطابق تمامًا",
  "wb.rules.text": "المرجع أولًا؛ ثم المبلغ ({{amount}}) والتاريخ خلال ±{{days}} يوم، بتأكيد شخص؛ والمتبقّي مفقود في أحد الجانبين.",
  "wb.reason.matched": "متطابق",
  "wb.reason.fuzzy": "متطابق · للتأكيد",
  "wb.reason.amount_mismatch": "اختلاف في المبلغ",
  "wb.reason.missing_in_erp": "مفقود في ERP",
  "wb.reason.missing_in_shopify": "مفقود في Shopify",
  "wb.reason.duplicate": "مكرّر",
  "wb.why.reference": "يذكر {{shop}} الأمر {{erp}} كأمره في ERPNext، والإجماليان متفقان.",
  "wb.why.amountSameDay": "لا يحمل {{shop}} مرجعًا في ERPNext؛ و{{erp}} هو الأمر الوحيد بالإجمالي نفسه في اليوم نفسه.",
  "wb.why.amountDayApart": "لا يحمل {{shop}} مرجعًا في ERPNext؛ و{{erp}} بالإجمالي نفسه بفارق يوم، غالبًا طلب مسائي سُجّل في اليوم التالي.",
  "wb.why.amountMismatch": "{{shop}} و{{erp}} الطلب نفسه، لكن إجمالي Shopify {{direction}} بمقدار {{delta}}: غالبًا شحن أو خصم سُجّل في جانب واحد فقط.",
  "wb.why.more": "أكثر",
  "wb.why.less": "أقل",
  "wb.why.duplicate": "{{shop}} طلب متجر ثانٍ يشير إلى {{erp}}؛ وسجّل ERPNext البيع مرة واحدة.",
  "wb.why.missingInErp": "لا يحمل {{shop}} مرجعًا ولا يوجد أمر ERPNext بإجماليه ضمن فارق التاريخ: لم يصل البيع إلى الدفاتر.",
  "wb.why.unknownReference": "يذكر {{shop}} الأمر {{erp}} الذي لم يرسله ERPNext إلى هذه الخلية.",
  "wb.why.missingInShopify": "يقع {{erp}} ضمن تواريخ المتجر لكن لا يطابقه أي طلب متجر: بيع هاتفي أو داخل المحل، أو طلب ويب مفقود.",
  "wb.review.keys": "المفاتيح:",
  "wb.review.accept": "قبول",
  "wb.review.reject": "رفض",
  "wb.review.showDecided": "إظهار ما حُسم",
  "wb.review.empty": "لا شيء متبقٍ للمراجعة. لكل زوج لم تحسمه القواعد حكمٌ.",
  "wb.review.queue": "أزواج للمراجعة",
  "wb.review.accepted": "مقبول",
  "wb.review.rejected": "مرفوض",
  "wb.review.acceptPair": "قبول الزوج",
  "wb.review.rejectPair": "رفض",
  "wb.review.recordedAccepted": "قُبل · الإيصال #{{seq}}",
  "wb.review.recordedRejected": "رُفض · الإيصال #{{seq}}",
  "wb.review.replayed": "مسجّل مسبقًا",
  "wb.review.wasAccepted": "قُبل سابقًا",
  "wb.review.wasRejected": "رُفض سابقًا",
  "wb.review.ledger": "فتح السجل",
  "wb.review.refused": "لم تسجّل الخلية هذا الحكم",
  "wb.review.alternatives": "أوامر ERPNext أخرى بالإجمالي والتاريخ نفسيهما: {{orders}}",
  "wb.review.summary": "{{open}} مفتوحة · {{decided}} محسومة",
  "wb.review.receipt": "الإيصال",
  "wb.chart.summary": "{{weeks}} أسبوع",
  "wb.chart.week": "الأسبوع",
  "wb.mean.shopOrder": "اسم الطلب الذي يراه الموظفون والعملاء في Shopify.",
  "wb.mean.placed": "متى وضع العميل الطلب، بتوقيت المتجر.",
  "wb.mean.shopTotal": "ما دُفع من العميل شاملًا الشحن والضريبة، كنص Shopify.",
  "wb.mean.financial": "هل دفع العميل (paid) أم ليس بعد (pending).",
  "wb.mean.email": "بريد العميل؛ بيانات الاتصال محجوبة ما لم يسمح دورك برؤيتها.",
  "wb.mean.reference": "أمر بيع ERPNext الذي سجّلته مزامنة المتجر على هذا الطلب، إن فعلت.",
  "wb.mean.erpOrder": "رقم أمر البيع في ERPNext.",
  "wb.mean.erpDate": "اليوم الذي سجّل فيه ERPNext الأمر.",
  "wb.mean.erpTotal": "الإجمالي الكلي للأمر في ERPNext.",
  "wb.mean.erpStatus": "مسودة أو مُعتمد وغير ذلك، من حالة مستند ERPNext.",
  "wb.mean.amount": "إجمالي Shopify مقروءًا رقمًا؛ فارغ إذا لم يكن النص رقمًا عشريًا بسيطًا.",
  "wb.mean.day": "اليوم التقويمي الذي رآه العميل، ويُستخدم لفارق التاريخ.",
  "wb.mean.verdict": "أي قاعدة قرنت الطلبين، وهل يتفق النظامان.",
  "wb.mean.confidence": "مدى ثقة القاعدة من 0 إلى 100: المرجع مع تساوي الإجمالي 100 (80 إن ذكر عميلًا آخر)؛ وزوج المبلغ + التاريخ 85 على الأكثر، و95 مع العميل نفسه، و40 مع عميل مختلف.",
  "wb.mean.delta": "كم زاد (أو نقص) ما حصّله Shopify عمّا سجّله ERPNext.",
  "wb.mean.days": "عدد الأيام بين يوم المتجر وتاريخ أمر ERPNext.",
  "wb.mean.erpCustomer": "العميل المسجَّل عليه الأمر في ERPNext، بالاسم؛ محجوب ما لم يسمح دورك برؤية بيانات الاتصال.",
  "wb.mean.customerSignal": "هل بريد طلب المتجر هو بريد العميل المسجَّل عليه الأمر في ERPNext (دون اعتبار حالة الأحرف). غير معروف حين يكون أحد البريدين محجوبًا أو غائبًا.",
  "wb.col.email": "البريد",
  "wb.customer.same": "العميل نفسه",
  "wb.customer.different": "عميل مختلف",
  "wb.customer.unknown": "العميل غير معروف",
  "wb.why.customerSame": "يذكر الطرفان العميل نفسه.",
  "wb.why.customerDifferent": "لكن عميل المتجر ({{shop}}) ليس عميل ERPNext ({{erp}}).",
  "wb.signal.customer": "العميل",
  "wb.signal.amount": "فرق المبلغ",
  "wb.signal.days": "فارق الأيام",
  "wb.signal.same": "لا شيء",
  "wb.mean.decision": "حكمك، تسجّله الخلية كإجراء مصرَّح به.",
  "wb.mean.receipt": "موضع الإجراء في السجل: دليل حدوثه.",
  "wb.mean.week": "يوم الاثنين من كل أسبوع؛ والأعمدة تعدّ الأزواج غير المتطابقة تمامًا.",
  "wb.promote.button": "رفع إلى مزامنة",
  "wb.promote.title": "رفع هذه المطابقة إلى مزامنة",
  "wb.promote.description": "تصبح قاعدة المرجع تعريفًا يعمل: كل طلب يرسله المتجر يحصل على زوجه في ERPNext، والطلبات بلا مرجع تنتظر هنا للمراجعة.",
  "wb.promote.generated": "مولَّد بواسطة Norn TypeScript SDK من",
  "wb.promote.maps": "{{system}} {{dataset}} ← {{target}}",
  "wb.promote.check": "المدقّق",
  "wb.promote.checking": "جارٍ التحقق مقابل تعريفات هذه الخلية…",
  "wb.promote.checkFailed": "لم يُجرَ التحقق",
  "wb.promote.admitted": "مقبول مقابل التعريفات المثبّتة في هذه الخلية.",
  "wb.promote.refused": "رفضه المدقّق:",
  "wb.promote.records": "يُرفع مع {{matched}} متطابقًا و{{review}} للمراجعة و{{unmatched}} غير متفق.",
  "wb.promote.install": "يسجّل الرفع المزامنة وبصمة تعريفها الدقيقة. تثبيت التحويل في الخلية تغيير تعريفات يقوم به مسؤول؛ وحتى ذلك تُدرجها المصادر › صحة المزامنة كمقترحة.",
  "wb.promote.confirm": "رفع",
  "wb.promote.pending": "جارٍ التسجيل…",
  "wb.promote.done": "تم",
  "wb.promote.recorded": "سُجّل · الإيصال #{{seq}}.",
  "wb.promote.seeSources": "اعرضها في المصادر",
  "wb.promote.notRecorded": "لم تسجّل الخلية الرفع",
  "wb.health.title": "صحة المزامنة",
  "wb.health.live": "تعمل",
  "wb.health.proposed": "مقترحة",
  "wb.health.admitted": "قبلها المدقّق",
  "wb.health.notAdmitted": "رفضها المدقّق",
  "wb.health.now": "الآن: {{matched}} متطابق · {{review}} للمراجعة · {{unmatched}} غير متفق",
  "wb.health.open": "دفتر العمل",
  "wb.health.none": "لم تُرفع أي مزامنة بعد.",
  "wb.health.openWorkbook": "افتح دفتر مطابقة الطلبات",
  "wb.needs.body": "{{missing}} طلب متجر لم يصل إلى ERPNext · {{unmatched}} زوجًا غير متفق",
  "wb.needs.open": "مراجعة",
  "wb.sheet.rows_zero": "لا صفوف",
  "wb.sheet.rows_one": "صف واحد",
  "wb.sheet.rows_two": "صفّان",
  "wb.sheet.rows_few": "{{count}} صفوف",
  "wb.sheet.rows_many": "{{count}} صفًا",
  "wb.sheet.rows_other": "{{count}} صف",
  "wb.sheet.showAll_zero": "لا صفوف",
  "wb.sheet.showAll_one": "عرض صف واحد",
  "wb.sheet.showAll_two": "عرض الصفّين",
  "wb.sheet.showAll_few": "عرض {{count}} صفوف",
  "wb.sheet.showAll_many": "عرض {{count}} صفًا",
  "wb.sheet.showAll_other": "عرض {{count}} صف",
  "wb.stat.outside_zero": "لا شيء خارج تواريخ المتجر",
  "wb.stat.outside_one": "واحد آخر خارج تواريخ المتجر",
  "wb.stat.outside_two": "اثنان آخران خارج تواريخ المتجر",
  "wb.stat.outside_few": "{{count}} أخرى خارج تواريخ المتجر",
  "wb.stat.outside_many": "{{count}} أخرى خارج تواريخ المتجر",
  "wb.stat.outside_other": "{{count}} أخرى خارج تواريخ المتجر",
  "wb.stat.decided_zero": "لم يُحسم شيء",
  "wb.stat.decided_one": "واحد محسوم",
  "wb.stat.decided_two": "اثنان محسومان",
  "wb.stat.decided_few": "{{count}} محسومة",
  "wb.stat.decided_many": "{{count}} محسومًا",
  "wb.stat.decided_other": "{{count}} محسوم",
  "wb.normalize.unreadable_zero": "قُرئت كل الصفوف",
  "wb.normalize.unreadable_one": "تعذّرت قراءة صف واحد",
  "wb.normalize.unreadable_two": "تعذّرت قراءة صفّين",
  "wb.normalize.unreadable_few": "تعذّرت قراءة {{count}} صفوف",
  "wb.normalize.unreadable_many": "تعذّرت قراءة {{count}} صفًا",
  "wb.normalize.unreadable_other": "تعذّرت قراءة {{count}} صف",
  "wb.needs.title_zero": "لا أزواج طلبات Shopify تحتاجك",
  "wb.needs.title_one": "زوج طلب Shopify واحد يحتاجك",
  "wb.needs.title_two": "زوجا طلبات Shopify يحتاجانك",
  "wb.needs.title_few": "{{count}} أزواج طلبات Shopify تحتاجك",
  "wb.needs.title_many": "{{count}} زوجًا من طلبات Shopify تحتاجك",
  "wb.needs.title_other": "{{count}} زوج طلبات Shopify يحتاجك",
  "wb.why.ambiguous_zero": "لا يحمل {{shop}} مرجعًا؛ و{{erp}} يناسبه.",
  "wb.why.ambiguous_one": "لا يحمل {{shop}} مرجعًا؛ {{erp}} يناسبه، ويناسبه أمر آخر أيضًا: اختر بعناية.",
  "wb.why.ambiguous_two": "لا يحمل {{shop}} مرجعًا؛ {{erp}} يناسبه، ويناسبه أمران آخران: اختر بعناية.",
  "wb.why.ambiguous_few": "لا يحمل {{shop}} مرجعًا؛ {{erp}} يناسبه، و{{count}} أوامر أخرى: اختر بعناية.",
  "wb.why.ambiguous_many": "لا يحمل {{shop}} مرجعًا؛ {{erp}} يناسبه، و{{count}} أمرًا آخر: اختر بعناية.",
  "wb.why.ambiguous_other": "لا يحمل {{shop}} مرجعًا؛ {{erp}} يناسبه، و{{count}} أمر آخر: اختر بعناية.",
  "wb.incomplete.truncated": "يحوي أحد المصادر صفوفًا أكثر مما يقرؤه دفتر العمل دفعة واحدة (10,000)، لذا أُوقفت المطابقة بدل الإبلاغ عن فجوات زائفة.",
  "wb.incomplete.refused": "تعذّرت قراءة أحد المصادر أو القرارات، لذا أُوقفت المطابقة بدل الإبلاغ عن فجوات زائفة.",
  "wb.kind.promote": "ترقية",
  "pw.title": "المدفوعات ← الدفاتر",
  "pw.description": "هل تتفق Paymob وKashier والبنك مع الدفاتر؟ تقرأ كل خلية ملفات التصدير الأصلية لمزوّدي الدفع ودفتر ERPNext من هذه الخلية؛ وتشرح المطابقة كل اختلاف بكلمات بسيطة، ويُسجَّل كل حكم كإجراء مصرَّح به مع إيصال.",
  "pw.list.body": "طابق تسويات Paymob وKashier وكشف الحساب البنكي مع فواتير ERPNext وقيود الدفع وقيود الرسوم، ثم رقِّ القيود كمزامنة مقترحة.",
  "pw.list.cells": "مصادر · تحويل · مطابقة · مراجعة · رسوم بيانية · ترقية",
  "pw.list.notInstalled": "لا توجد ملفات مزوّدي دفع في هذه الخلية بعد.",
  "pw.notInstalled": "لا توجد ملفات مزوّدي دفع في هذه الخلية",
  "pw.notInstalledBody": "يحتاج دفتر العمل إلى الأنواع paymob.Transaction وkashier.PayoutLine وledger.SalesInvoice. ثبّت تعريفات المدفوعات لاستخدامه.",
  "pw.stat.transactions": "معاملات المزوّدين",
  "pw.stat.providers": "Paymob {{paymob}} · Kashier {{kashier}}",
  "pw.stat.posted": "مرحَّلة",
  "pw.stat.toPost": "للترحيل",
  "pw.stat.decided": "تم البت: {{n}}",
  "pw.stat.unreconciled": "غير مطابَق",
  "pw.stat.fees": "الرسوم + الضريبة",
  "pw.stat.feesHint": "جنيه، للمزوّدين معًا",
  "pw.lens.financeOnly": "للمالية فقط",
  "pw.lens.note": "الرسوم والضريبة وصافي الدفعات تظهر للمالية فقط؛ يرى دورك المبالغ والمطابقات، وتنتظر فحوص الرسوم المالية.",
  "pw.lens.chartHidden": "رسوم المزوّدين مخفية لدورك. تعرضها عدسة المالية حسب المزوّد والأسبوع.",
  "pw.cell.paymob": "تصدير معاملات Paymob",
  "pw.cell.settlements": "تقرير تسويات Paymob",
  "pw.cell.kashier": "تقرير دفعات Kashier",
  "pw.cell.bank": "كشف الحساب البنكي",
  "pw.cell.ledger": "دفتر ERPNext",
  "pw.cell.normalize": "شكل دفع واحد للمزوّدين",
  "pw.cell.matchTxns": "المعاملات ↔ الفواتير وقيود الدفع",
  "pw.cell.matchBatches": "دفعات التسوية ↔ إيداعات البنك",
  "pw.cell.review": "راجِع النتائج",
  "pw.cell.feesChart": "الرسوم حسب المزوّد والأسبوع",
  "pw.cell.unreconciledChart": "المبلغ غير المطابَق عبر الزمن",
  "pw.cell.promote": "القيود المقترحة",
  "pw.ledger.summary": "{{invoices}} فاتورة · {{payments}} قيد دفع · {{journals}} قيد يومية",
  "pw.ledger.invoices": "فواتير المبيعات",
  "pw.ledger.payments": "قيود الدفع",
  "pw.ledger.journals": "قيود اليومية",
  "pw.col.transaction": "المعاملة",
  "pw.col.type": "النوع",
  "pw.col.storeOrder": "طلب المتجر",
  "pw.col.instrument": "البطاقة أو المحفظة",
  "pw.col.batch": "دفعة التسوية",
  "pw.col.provider": "المزوّد",
  "pw.col.gross": "الإجمالي",
  "pw.col.fee": "الرسوم",
  "pw.col.vat": "الضريبة",
  "pw.col.net": "الصافي",
  "pw.col.erp": "مستند ERPNext",
  "pw.col.delta": "Δ",
  "pw.col.lines": "مجموع البنود",
  "pw.col.reported": "المدفوع",
  "pw.col.deposit": "بند البنك",
  "pw.col.feeJournal": "قيد الرسوم",
  "pw.col.proposal": "سينشئ",
  "pw.kind.capture": "دفع",
  "pw.kind.refund": "استرداد",
  "pw.kind.chargeback": "رد مبلغ",
  "pw.empty.source": "لم تصل أي صفوف بعد.",
  "pw.normalize.body": "تصدّر Paymob المبالغ بالقرش (\"150050\" تعني 1,500.50 جنيه) وبتوقيت القاهرة المحلي؛ وتصدّر Kashier جنيهات بإشارة ولحظات UTC. تقرأ هذه الخلية الاثنين كجنيهات بإشارة (الاسترداد ورد المبلغ بالسالب) في يوم القاهرة، وتحتفظ بجانبها برسوم كل مزوّد وضريبتها ودفعة التسوية.",
  "pw.normalize.unreadable": "تعذّرت قراءة {{n}} صف",
  "pw.match.summary": "{{n}} معاملة · {{review}} للمراجعة · {{toPost}} للترحيل",
  "pw.batches.summary": "{{n}} دفعة · {{review}} للمراجعة",
  "pw.filter.review": "تحتاج إلى شخص",
  "pw.rule.posted": "مرحَّلة",
  "pw.rule.postedBody": "قيد دفع معتمد رقمه المرجعي هو رقم معاملة المزوّد: المعاملة في الدفاتر.",
  "pw.rule.invoice": "الفاتورة",
  "pw.rule.invoiceBody": "وإلا فطلب المتجر يقود إلى أمر البيع في ERPNext وفاتورته: مستحقة ← للترحيل؛ مدفوعة ← يتحقق شخص؛ لا توجد ← لا فاتورة.",
  "pw.rule.fee": "الرسوم",
  "pw.rule.feeBody": "يجب أن تطابق رسوم كل معاملة العقد: Paymob {{paymob}}، Kashier {{kashier}}، مع ضريبة 14% على الرسوم. تحصيل ثانٍ للطلب والمبلغ نفسيهما مكرر.",
  "pw.rule.refund": "الاسترداد",
  "pw.rule.refundBody": "يُعدّ الاسترداد مقيدًا عندما يكون لفاتورته إشعار دائن بالمبلغ؛ ورد المبلغ يحتاج دائمًا إلى شخص.",
  "pw.rule.sum": "المجموع",
  "pw.rule.sumBody": "يجب أن يساوي صافي معاملات الدفعة بعد الرسوم ما يقول المزوّد إنه دفعه.",
  "pw.rule.deposit": "الإيداع",
  "pw.rule.depositBody": "بند البنك الذي يحمل مرجع الدفعة هو إيداعها؛ وإلا فبند بالمبلغ نفسه خلال يومين، ليؤكده شخص.",
  "pw.rule.missing": "مفقودة",
  "pw.rule.missingBody": "دفعة يقول المزوّد إنها حُوّلت ولا يظهر لها بند في البنك لم تصل.",
  "pw.rules.text": "رقم معاملة المزوّد = الرقم المرجعي لقيد الدفع؛ وإلا ففاتورة ERPNext لطلب المتجر؛ الرسوم حسب العقد (Paymob {{paymob}}، Kashier {{kashier}}، ضريبة 14%)؛ دفعات التسوية إلى بنود البنك بالمرجع، وإلا بالمبلغ خلال يومين.",
  "pw.reason.posted": "مرحَّلة",
  "pw.reason.to_post": "للترحيل",
  "pw.reason.refund_booked": "استرداد مقيد",
  "pw.reason.fee_mismatch": "اختلاف الرسوم",
  "pw.reason.duplicate_capture": "تحصيل مكرر",
  "pw.reason.no_invoice": "لا فاتورة",
  "pw.reason.already_paid": "مدفوعة مسبقًا",
  "pw.reason.refund_no_credit_note": "استرداد بلا إشعار دائن",
  "pw.reason.chargeback": "رد مبلغ",
  "pw.reason.deposited": "مودَعة",
  "pw.reason.deposit_by_amount": "إيداع بالمبلغ",
  "pw.reason.batch_not_sum": "مجموع الدفعة لا يتطابق",
  "pw.reason.missing_payout": "دفعة مفقودة",
  "pw.reason.deposit_mismatch": "الإيداع مختلف",
  "pw.why.posted": "{{provider}} {{id}} مقيدة في الدفاتر برقم {{erp}}.",
  "pw.why.postedCheck": "يسجل {{erp}} المعاملة {{provider}} {{id}}، لكن مبلغه أو وسيلة الدفع أو الفاتورة لا تتفق مع المعاملة: تحقق من أنه القيد الصحيح.",
  "pw.why.toPost": "دفعت {{id}} طلب المتجر {{order}}؛ وفاتورته {{erp}} ما زالت مستحقة، فتقترح المزامنة قيد الدفع.",
  "pw.why.toPostDelta": "دفعت {{id}} طلب المتجر {{order}}؛ وفاتورته {{erp}} مستحق عليها مبلغ مختلف (بفارق {{delta}})، غالبًا شحن حُصّل عبر الإنترنت فقط.",
  "pw.why.refundBooked": "الاسترداد {{id}} بقيمة {{amount}} جنيه مقيد كإشعار دائن {{erp}}.",
  "pw.why.feeMismatch": "حصّلت {{provider}} {{charged}} رسومًا وضريبة على {{id}}، بينما ينص العقد على {{expected}}: زيادة {{delta}}.",
  "pw.why.duplicateCapture": "حصّلت {{id}} طلب المتجر {{order}} مرة ثانية ({{amount}} جنيه، التحصيل الأول {{first}}): خُصم من العميل مرتين.",
  "pw.why.noInvoice": "دفعت {{id}} طلب المتجر {{order}}، لكن لا توجد في ERPNext فاتورة معتمدة له.",
  "pw.why.noReference": "دفعت {{id}} طلب المتجر {{order}}، الذي لا يحمل مرجع ERPNext بعد: احسمه في دفتر عمل طلبات Shopify ↔ ERPNext، ثم يمكن إيجاد فاتورته.",
  "pw.why.noStoreOrder": "تشير {{id}} إلى طلب المتجر {{order}}، الذي لم يصل إلى ERPNext.",
  "pw.why.alreadyPaid": "كانت {{id}} ستسدد {{erp}}، لكن ERPNext يظهرها مدفوعة: دفعة ثانية، أو دفعة قُيّدت عبر وسيلة أخرى.",
  "pw.why.refundNoCreditNote": "ردّت {{id}} مبلغ {{amount}} جنيه على طلب المتجر {{order}}، لكن الفاتورة {{erp}} بلا إشعار دائن: ما زال الإيراد مضخَّمًا.",
  "pw.why.chargeback": "اعترض حامل البطاقة على طلب المتجر {{order}}: استردت {{id}} مبلغ {{amount}} جنيه مع رسوم رد المبلغ.",
  "pw.why.deposited": "وصلت دفعة {{provider}} رقم {{batch}} كبند بنكي {{ref}} في {{date}}.",
  "pw.why.depositByAmount": "لا يوجد للدفعة {{batch}} بند بنكي بمرجعها {{expected}}؛ للبند {{ref}} المبلغ نفسه خلال يومين.",
  "pw.why.batchNotSum": "تقول {{provider}} إن الدفعة {{batch}} دفعت {{reported}}، لكن صافي معاملاتها {{lines}}: {{delta}} بلا تفسير.",
  "pw.why.missingPayout": "تقول {{provider}} إن الدفعة {{batch}} حُوّلت في {{date}} (المرجع {{ref}})، لكن لا يظهرها أي بند بنكي.",
  "pw.why.depositMismatch": "يختلف بند البنك {{ref}} للدفعة {{batch}} عما يذكره المزوّد بمقدار {{delta}}.",
  "pw.review.accept": "قبول",
  "pw.review.queue": "نتائج للمراجعة",
  "pw.review.empty": "لم يبق شيء للمراجعة. لكل نتيجة لم تحسمها القواعد حكم.",
  "pw.side.bank": "البنك",
  "pw.side.noDeposit": "لا يظهر أي بند بنكي هذه الدفعة.",
  "pw.detail.contract": "العقد {{fee}} + {{vat}}",
  "pw.detail.owed": "مستحق",
  "pw.detail.first": "التحصيل الأول",
  "pw.chart.cumulative": "التراكمي",
  "pw.unreconciled.summary": "{{amount}} جنيه مفتوحة",
  "pw.promote.summary": "{{entries}} قيد دفع · {{journals}} قيد رسوم",
  "pw.promote.body": "تسجّل الترقية مزامنتين ولّدتهما حزمة TypeScript، واحدة لكل مزوّد. بعد التثبيت تقترح كل منهما قيود الدفع هذه (في حساب المقاصة للمزوّد، والرقم المرجعي هو المعاملة) وقيد رسوم واحدًا لكل دفعة (الرسوم والضريبة مقابل المقاصة). تبقى مقترحات: لا يُكتب شيء في ERPNext.",
  "pw.promote.none": "لا شيء ينتظر الترحيل.",
  "pw.promote.title": "رقِّ مطابقة المدفوعات إلى مزامنات",
  "pw.promote.description": "تصبح قواعد كل مزوّد تعريفًا عاملًا يقترح قيود الدفع وقيود الرسوم في ERPNext التي تقتضيها ملفاته؛ وتبقى النتائج هنا بانتظار شخص.",
  "pw.promote.install": "تسجّل الترقية كل مزامنة وبصمة تعريفها الدقيقة كاقتراح. تثبيت التعيين تغيير تعريفات يجريه المسؤول، ولا يصل أي قيد إلى ERPNext دون موافقة.",
  "pw.mean.paymobId": "رقم معاملة Paymob: المرجع الذي يسجله قيد الدفع.",
  "pw.mean.kashierId": "رقم معاملة Kashier: المرجع الذي يسجله قيد الدفع.",
  "pw.mean.type": "دفع أو استرداد أو رد مبلغ.",
  "pw.mean.storeOrder": "طلب المتجر الذي دفعته عملية الشراء (رقم طلب Shopify).",
  "pw.mean.amountCents": "المبلغ بالقرش، كما تصدّره Paymob.",
  "pw.mean.grossEgp": "المبلغ بالجنيه بإشارة: الاسترداد بالسالب.",
  "pw.mean.instrument": "نوع البطاقة وآخر أرقامها، أو المحفظة؛ للمالية فقط.",
  "pw.mean.fee": "رسوم المزوّد والضريبة عليها؛ للمالية فقط.",
  "pw.mean.vat": "ضريبة 14% على رسوم المزوّد؛ للمالية فقط.",
  "pw.mean.settlement": "التسوية التي دفعت هذا، إن وُجدت.",
  "pw.mean.payout": "الدفعة التي ينتمي إليها هذا الصف.",
  "pw.mean.reportedNet": "ما يقول المزوّد إنه دفعه إلى البنك؛ للمالية فقط.",
  "pw.mean.bankReference": "مرجع البنك للتحويل.",
  "pw.mean.bankLine": "مرجع البنك الخاص بالبند.",
  "pw.mean.credit": "الوارد، بالجنيه؛ للمالية فقط.",
  "pw.mean.invoice": "الفواتير والإشعارات الدائنة، مع أمر البيع الذي تفوتره كل منها.",
  "pw.mean.paymentEntry": "المدفوعات في الدفاتر، مع معاملة المزوّد التي يسجلها كل منها.",
  "pw.mean.journal": "قيود الرسوم والإيداعات البنكية، مرتبطة بدفعتها عبر cheque_no.",
  "pw.mean.gross": "ما دفعه العميل (أو استرده)، بالجنيه.",
  "pw.mean.day": "يوم القاهرة للحركة.",
  "pw.mean.batch": "التسوية أو الدفعة التي تنقل الحركة إلى البنك.",
  "pw.mean.verdict": "القاعدة التي حسمت المعاملة، أو سبب احتياجها إلى شخص.",
  "pw.mean.confidence": "مدى يقين القاعدة، من 0 إلى 100: قيد وُجد بالمرجع 100؛ وإيداع وُجد بالمبلغ فقط 65.",
  "pw.mean.erp": "قيد الدفع أو الفاتورة أو الإشعار الدائن الذي يستند إليه الحكم.",
  "pw.mean.delta": "الإجمالي ناقص ما في الدفاتر؛ وفي اختلاف الرسوم، المحصَّل ناقص العقد.",
  "pw.mean.lines": "صافي معاملات الدفعة بعد الرسوم، مجموعًا؛ يحتاج عرض المالية.",
  "pw.mean.deposit": "بند البنك الذي حمل الدفعة.",
  "pw.mean.feeJournal": "قيد الرسوم المسجل للدفعة، إن وُجد.",
  "pw.mean.feesChart": "رسوم كل مزوّد وضريبتها أسبوعيًا؛ للمالية فقط.",
  "pw.mean.unreconciledChart": "الإجمالي الذي لم يدخل الدفاتر أسبوعيًا: بانتظار الترحيل أو بانتظار شخص؛ والخط هو المجموع الجاري.",
  "pw.mean.proposedEntry": "قيد دفع واحد لكل تحصيل ناجح.",
  "pw.mean.proposedJournal": "سطر قيد رسوم واحد لكل تسوية أو صف دفعة.",
  "lens.hidden": "مخفي",
  "lens.hiddenForRole": "مخفي عن دورك",
  "lens.whyHidden": "لماذا لا أرى هذا؟",
  "lens.markedAs": "هذا الحقل مُصنَّف {{label}}.",
  "lens.revealedBy": "تسمّي سياسة {{policy}} الأدوار {{roles}} له، في القاعدة",
  "lens.anyRole": "أي دور",
  "lens.noReveal": "لا توجد سياسة مثبتة تكشف هذا التصنيف لأي أحد.",
  "lens.whoGrants": "يمكن للمسؤول عن هذه السياسات منح أحد الأدوار المسمّاة؛ ويحتاج الدور أيضًا إلى صلاحية الكشف، والخلية تقرر كل قراءة.",
  "lens.serverSide": "حجبت الخلية القيمة قبل وصولها إلى هذا المتصفح؛ هذه الملاحظة تقرأ السياسة المثبتة.",
  "lens.viewingAs": "العرض بصفة {{lens}}",
  "lens.switch": "تبديل منظور القسم",
  "lens.viewAs": "العرض بصفة",
  "ac.queue.title": "بانتظارك",
  "ac.queue.description": "أعمال تنتظر أحدًا، عبر التطبيقات، من السجلات نفسها.",
  "ac.queue.overdueDetail": "{{key}} · كان مستحقًا في {{due}}",
  "ac.queue.unmatchedDetail": "غير مطابق لأمر بيع في ERPNext",
  "ac.queue.lowStockDetail": "{{have}} متاح · إعادة الطلب عند {{floor}}",
  "ac.queue.openIn": "فتح في {{app}}",
  "ac.queue.more": "{{count}} أخرى",
  "ac.app.sell": "البيع",
  "ac.app.sellHint": "نقطة البيع والفواتير وطلبات المتجر",
  "ac.app.cash": "عمليات النقد",
  "ac.app.cashHint": "التحصيلات والحسابات والمدفوعات",
  "ac.app.crm": "إدارة العملاء",
  "ac.app.crmHint": "العملاء والقنوات والمناسبات",
  "ac.app.studio": "الاستوديو",
  "ac.app.studioHint": "تصوير المنتجات ومهام التوليد",
  "ac.app.inventory": "المخزون",
  "ac.app.inventoryHint": "مستويات المخزون وحدود إعادة الطلب",
  "ac.apps.title": "التطبيقات",
  "ac.kpi.grossMargin": "إجمالي هامش الربح",
  "ac.kpi.commission": "عمولة المبيعات",
  "ac.kpi.overdue": "فواتير متأخرة",
  "ac.kpi.unmatched": "طلبات متجر غير مطابقة",
  "ac.kpi.usesHidden": "استخدمت الخلية {{label}} في {{type}} لحساب هذا؛ يبقى الرقم مخفيًا عن دورك",
  "ac.kpi.fromRecords": "جمعته الخلية من {{type}}",
  "ac.sync.title": "حالة المزامنة",
  "ac.sync.rejected": "{{value}} مرفوض",
  "ac.queue.overdue_zero": "لا توجد فواتير متأخرة",
  "ac.queue.overdue_one": "فاتورة متأخرة واحدة",
  "ac.queue.overdue_two": "فاتورتان متأخرتان",
  "ac.queue.overdue_few": "{{count}} فواتير متأخرة",
  "ac.queue.overdue_many": "{{count}} فاتورة متأخرة",
  "ac.queue.overdue_other": "{{count}} فاتورة متأخرة",
  "ac.queue.unmatched_zero": "لا توجد طلبات متجر غير مطابقة",
  "ac.queue.unmatched_one": "طلب متجر واحد غير مطابق",
  "ac.queue.unmatched_two": "طلبا متجر غير مطابقين",
  "ac.queue.unmatched_few": "{{count}} طلبات متجر غير مطابقة",
  "ac.queue.unmatched_many": "{{count}} طلب متجر غير مطابق",
  "ac.queue.unmatched_other": "{{count}} طلب متجر غير مطابق",
  "ac.queue.lowStock_zero": "لا توجد أصناف تحت حد إعادة الطلب",
  "ac.queue.lowStock_one": "صنف واحد تحت حد إعادة الطلب",
  "ac.queue.lowStock_two": "صنفان تحت حد إعادة الطلب",
  "ac.queue.lowStock_few": "{{count}} أصناف تحت حد إعادة الطلب",
  "ac.queue.lowStock_many": "{{count}} صنفًا تحت حد إعادة الطلب",
  "ac.queue.lowStock_other": "{{count}} صنف تحت حد إعادة الطلب",
  "ac.queue.approval_zero": "لا توجد أوامر بيع بانتظار الموافقة",
  "ac.queue.approval_one": "أمر بيع واحد بانتظار الموافقة",
  "ac.queue.approval_two": "أمرا بيع بانتظار الموافقة",
  "ac.queue.approval_few": "{{count}} أوامر بيع بانتظار الموافقة",
  "ac.queue.approval_many": "{{count}} أمر بيع بانتظار الموافقة",
  "ac.queue.approval_other": "{{count}} أمر بيع بانتظار الموافقة",
  "ac.queue.approvalDetail": "مُقدّم أو معلّق · يحتاج إلى موافقة",
  "ac.kpi.overdueSub_zero": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.overdueSub_one": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.overdueSub_two": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.overdueSub_few": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.overdueSub_many": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.overdueSub_other": "{{count}}{{more}} بانتظار التحصيل",
  "ac.kpi.unmatchedSub_zero": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.unmatchedSub_one": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.unmatchedSub_two": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.unmatchedSub_few": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.unmatchedSub_many": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.unmatchedSub_other": "{{count}}{{more}} بحاجة إلى أمر بيع",
  "ac.kpi.lowStockSub_zero": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.lowStockSub_one": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.lowStockSub_two": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.lowStockSub_few": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.lowStockSub_many": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.lowStockSub_other": "{{count}}{{more}} لإعادة الطلب",
  "ac.kpi.approvalSub_zero": "{{count}}{{more}} بانتظار الموافقة",
  "ac.kpi.approvalSub_one": "{{count}}{{more}} بانتظار الموافقة",
  "ac.kpi.approvalSub_two": "{{count}}{{more}} بانتظار الموافقة",
  "ac.kpi.approvalSub_few": "{{count}}{{more}} بانتظار الموافقة",
  "ac.kpi.approvalSub_many": "{{count}}{{more}} بانتظار الموافقة",
  "ac.kpi.approvalSub_other": "{{count}}{{more}} بانتظار الموافقة",
  "ac.sync.records_zero": "{{value}} سجل",
  "ac.sync.records_one": "{{value}} سجل",
  "ac.sync.records_two": "{{value}} سجل",
  "ac.sync.records_few": "{{value}} سجل",
  "ac.sync.records_many": "{{value}} سجل",
  "ac.sync.records_other": "{{value}} سجل",
  "connections.title": "حالة الاتصالات",
  "connections.refresh": "تحديث",
  "connections.description": "مصادر للقراءة فقط. تبدأ المزامنة بعد توفير بيانات الاعتماد والموافقة المطلوبة.",
  "connections.empty": "لم تُضبط اتصالات لهذا النطاق.",
  "connections.unavailable": "تعذّرت قراءة حالة الاتصالات.",
  "connections.protocolError": "أعاد الخادم استجابة غير مدعومة لحالة الاتصالات.",
  "connections.readOnly": "للقراءة فقط · لا تغييرات على المصدر",
  "connections.missing": "بانتظار بيانات الاعتماد",
  "connections.lastSuccess": "آخر مزامنة ناجحة",
  "connections.never": "لم تنجح أي مزامنة بعد",
  "connections.records": "السجلات المُبلّغ عنها",
  "connections.retry": "المحاولة التالية",
  "connections.noRetry": "غير مجدولة",
  "connections.failure": "آخر مشكلة مزامنة:",
  "connections.gmailSetup": "تفاصيل إعداد Gmail",
  "connections.callback": "عنوان إعادة الاتصال لـ OAuth",
  "connections.connecting": "جارٍ فتح الموافقة…",
  "connections.connectGmail": "ربط Gmail",
  "connections.status.waiting_for_credential": "بانتظار بيانات الاعتماد",
  "connections.status.awaiting_consent": "بانتظار الموافقة",
  "connections.status.ready": "جاهز للمزامنة",
  "connections.status.syncing": "جارٍ المزامنة",
  "connections.status.healthy": "محدّث",
  "connections.status.error": "يحتاج إلى مراجعة",
  "connections.status.disabled": "معطّل",
} satisfies Record<MessageKey, string> & Record<string, string>
